webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setWebShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sharePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setPageTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return imgStr2Arr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return queryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchAjax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inOtherBroswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return statistics; });
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTop;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return canvasSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isObjectFitCompatible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zepto__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zepto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_zepto__);





var app = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].app,
    hosts = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].hosts,
    appInfo = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].appInfo;

var toast = function toast(msg) {
  __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default()({
    message: msg,
    position: 'bottom',
    duration: 2000,
    className: 'm-toast'
  });
};

var setWebShare = function setWebShare(shareInfo) {
  app.appWebShare({
    isShow: true,
    title: shareInfo.title,
    describe: shareInfo.content,
    shareImg: shareInfo.imageUrl,
    link: shareInfo.titleUrl
  });
};

var sharePage = function sharePage(shareInfo) {
  app.shareWebPage(shareInfo);
};

var setPageTitle = function setPageTitle(title) {
  document.title = title;
};

var imgStr2Arr = function imgStr2Arr(imgStr) {
  var arr = imgStr.split('|');
  var imgArr = [];
  for (var i = 0, len = arr.length; i < len; i++) {
    var temp = arr[i].split(',');
    var o = {
      id: temp[0],
      src: hosts.showimg + temp[1],
      index: temp[2],
      size: temp[3]
    };
    imgArr.push(o);
  }
  return imgArr;
};

var queryString = function queryString(k, s) {
  var r, t;
  s = s || '?';
  k = k.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
  r = new RegExp('[\\' + s + '&]' + k + '=([^&#]*)');
  t = r.exec(window.location.href);
  return t == null ? '' : t[1];
};

var fetch = function fetch(options) {
  return function () {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4_zepto___default.a.ajax({
        url: options.url,
        data: options.data || {},
        type: options.type || 'GET',
        dataType: options.dataType || 'none',
        callback: options.callback || 'callback',
        timeout: 5000,
        success: resolve,
        error: reject,
        headers: {
          'Access-Token': app.getToken() || ''
        }
      });
    });
  };
};

var fetchAjax = function fetchAjax(options) {
  return function () {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      app.ajax({
        url: options.url,
        params: options.data || {},
        type: options.type || 'GET',
        dataType: options.dataType || 'json',
        success: resolve,
        error: reject
      });
    });
  };
};

var inOtherBroswer = function inOtherBroswer() {
  if (appInfo) {
    return false;
  }
  var scheme = 'WebPage?url=' + window.location.href;
  window.location.href = hosts.main + '/ZT/wap/openapp/index.html?scheme=' + encodeURIComponent(scheme) + '&pagename=live&frompage108sq=fromwx';
  return true;
};

var isLogin = function isLogin() {
  if (app.getToken()) {
    return true;
  }
  app.toLogin(true);
  return false;
};

var statistics = function statistics(eventName, postId) {
  app.webStatistics({
    pageName: 'Teletext',
    eventName: eventName,
    SiteId: appInfo ? appInfo.cityId : 0,
    TeletextId: queryString('id'),
    PostId: postId || 0
  });
};

function scrollTop(el) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments[2];
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    };
  }
  var difference = Math.abs(from - to);
  var step = Math.ceil(difference / duration * 50);

  function scroll(start, end, step, cb) {
    if (start === end) {
      cb();
      return;
    }

    var d = start + step > end ? end : start + step;
    if (start > end) {
      d = start - step < end ? end : start - step;
    }

    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }
    window.requestAnimationFrame(function () {
      return scroll(d, end, step, cb);
    });
  }
  scroll(from, to, step, cb);
}

var canvasSupported = function () {
  return !!document.createElement('canvas').getContext;
}();

var isObjectFitCompatible = function () {
  var sty = document.createElement('div').style;
  return 'objectFit' in sty;
}();

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);








var ua = window.navigator.userAgent;

var isDebug = /:[\d]+$/.test(window.location.host);

var isApp = /108sq/i.test(ua);
var isAndroid = /android/i.test(ua);
var isIPhone = /iphone/i.test(ua);

function jsonpRequest(options) {
  var script = document.createElement('script');
  if (options.callback) {
    window[options.callback] = options.success || function () {};
  } else {
    var random = parseInt(Math.random() * 1000000) + 1000000;
    options.callback = '_jsonpCallback' + random;
    window[options.callback] = options.success || function () {};
  }
  script.onload = function () {
    this.parentNode.removeChild(this);
  };
  script.onerror = function () {
    this.parentNode.removeChild(this);
  };
  var head = document.querySelector('head');
  head.appendChild(script);
  script.src = options.url + '?callback=' + options.callback + '&' + j2p(options.params);
}

function j2p(json) {
  var arr = [];
  for (var i in json) {
    json.hasOwnProperty(i) && arr.push(i + '=' + json[i]);
  }
  return arr.join('&');
}

function getOS() {
  var u = navigator.userAgent;
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    return 'Android';
  } else if (u.indexOf('iPhone') > -1) {
    return 'iPhone OS';
  } else if (u.indexOf('Windows Phone') > -1) {
    return 'Windows Mobile';
  }
  return '';
}

var appInfo;
var ua$1 = window.navigator.userAgent;
if (isApp) {
  var reg = /108sq\/([^/]*)\/([^/]*)\/([^/]*)\/([^/]*)$/i;
  var match = ua$1.match(reg);
  appInfo = {
    name: '108sq',
    version: match ? match[1] : '',
    cityId: match ? match[2] : '',
    channelName: match ? match[3] : '',
    netType: match ? match[4] : ''
  };
} else {
  appInfo = null;
}

var appInfo$1 = appInfo;

var hosts = isDebug ? {
  main: 'http://www.108sq.org:920',
  app: 'http://app.108sq.org:920',
  login: 'http://login.108sq.org:807',
  userop: 'http://userop.108sq.org:1204',
  discuss: 'http://discuss.108sq.org:901',
  discuss1: 'http://discuss1.108sq.org:1202',
  uploadimg: 'http://photo.108sq.org:811',
  showimg: 'http://photoshow.108sq.org:814',
  merchant: 'http://sj.108sq.org:703',
  activity: 'http://huodong.108sq.org:815',
  shuo: 'http://shuo.108sq.org:821',
  shuocdn: 'http://shuo.108sq.org:821',
  dynamic: 'http://dynamic.108sq.org:826',
  mtalk: 'http://mtalksvc.108sq.org:831',
  shop: 'http://shop.108sq.org:1505',
  dynamicnew: 'http://dynamic.108sq.org:826',
  jiangli: 'http://jiangli.tc108.org:1505',
  love: 'http://love.108sq.org:1505',
  pay: 'http://pay.108sq.org:1203',
  friendv2: 'http://friendv2.108sq.org:1505',
  friend: 'http://friend.108sq.org:806',
  pkplugin: 'http://pkplugin.108sq.org:1505',
  business: 'http://business.108sq.org:920',
  message: 'http://message.108sq.org:809',
  businessad: 'http://businessad.108sq.org:71',
  enrolling: 'http://enrolling.108sq.org:1505',
  m: 'http://m.108sq.org:920',
  nodomain: 'http://108sq.org:920',
  mtalksvcv2: 'http://mtalksvcv2.108sq.org:831',
  mtalksvc: 'http://mtalksvc.108sq.org:831',
  common: 'http://common.108sq.org:1505',

  usertxcdn: 'http://usertxcdn.108sq.org:920',
  vote: 'http://vote.108sq.org:1505',
  images: 'http://images.108sq.org:920'
} : {
  main: 'http://www.108sq.cn',
  app: 'http://app.108sq.cn',
  login: 'http://login.108sq.cn',
  userop: 'http://userop.108sq.cn',
  discuss: 'http://discuss.108sq.cn',
  discuss1: 'http://discuss.108sq.cn',
  uploadimg: 'http://photo.108sq.cn',
  showimg: 'http://photoshow.108sq.cn',
  merchant: 'http://sj.108sq.cn',
  activity: 'http://huodong.108sq.cn',
  shuo: 'http://shuo.108sq.cn',
  shuocdn: 'http://shuocdn.108sq.cn',
  dynamic: 'http://dynamic.108sq.cn',
  mtalk: 'http://mtalksvc.tc108.net',
  shop: 'http://shop.108sq.cn',
  dynamicnew: 'http://dynamic.108sq.cn',
  jiangli: 'http://jiangli.108sq.cn',
  love: 'http://love.108sq.cn',
  pay: 'http://pay.108sq.cn',
  friendv2: 'http://friendv2.108sq.cn',
  friend: 'http://friend.108sq.cn',
  pkplugin: 'http://pkplugin.108sq.cn',
  business: 'http://business.108sq.cn',
  message: 'http://message.108sq.cn',
  businessad: 'http://businessad.108sq.cn',
  enrolling: 'http://enrolling.108sq.cn',
  m: 'http://m.108sq.cn',
  nodomain: 'http://108sq.cn',
  mtalksvcv2: 'http://mtalksvcv2.sq108.net',
  mtalksvc: 'http://mtalksvc.sq108.net',
  common: 'http://common.108sq.cn',
  usertxcdn: 'http://usertxcdn.108sq.cn',
  vote: 'http://vote.108sq.cn',
  images: 'http://images.108sq.cn'
};

var ajax = function ajax(configs) {
  var defaults = {
    type: 'GET',
    url: '',
    waiting: '',
    params: {},
    success: null,
    error: null,
    complete: null,
    isNeedDecode: false
  };
  var options = {};
  for (var i in defaults) {
    options[i] = configs.hasOwnProperty(i) ? configs[i] : defaults[i];
  }
  var j2p = function j2p(json) {
    var a = [];
    for (var i in json) {
      a.push(i + '=' + json[i]);
    }return a.join('&');
  };
  var random = parseInt(Math.random() * 1000000000000 + 1000000000000);
  var success = '';
  var error = '';
  var complete = '';
  if (options.success) {
    success = 'APP_CALLBACK_SUCCESS_' + random;
    window[success] = function (response) {
      if (typeof response === 'string') {
        response = JSON.parse(response);
      }
      options.success && options.success.call(window, response);
    };
  }
  if (options.error) {
    error = 'APP_CALLBACK_ERROR_' + random;
    window[error] = function () {
      options.error && options.error.call(window);
    };
  }
  if (options.complete) {
    complete = 'APP_CALLBACK_COMPLETE_' + random;
    window[complete] = function () {
      options.complete && options.complete(window);
    };
  }

  var params = {
    type: options.type.toUpperCase(),
    url: options.url,
    waiting: options.waiting,
    params: j2p(options.params),
    success: success,
    error: error,
    complete: complete,
    isNeedDecode: options.isNeedDecode
  };

  this._callMethod('ajax', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(params));
};

var ajax$1 = ajax;

var _typeof = typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator___default.a) === "symbol" ? function (obj) {
  return typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj);
} : function (obj) {
  return obj && typeof __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj);
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var openUpload = function openUpload(configs) {
  var defaults$$1 = {
    url: '',
    waiting: '',

    maxwidth: 0,

    quality: 100,

    dataType: 'json',
    params: {},
    start: null,
    cancel: null,
    success: null,
    failure: null,
    complete: null
  };
  var options = {};
  for (var i in defaults$$1) {
    options[i] = configs.hasOwnProperty(i) ? configs[i] : defaults$$1[i];
  }
  var j2p = function j2p(json) {
    var a = [];
    for (var i in json) {
      a.push(i + '=' + json[i]);
    }return a.join('&');
  };
  var random = parseInt(Math.random() * 1000000000000 + 1000000000000);
  var start = '';
  var cancel = '';
  var success = '';
  var failure = '';
  var complete = '';
  if (options.start) {
    start = 'APP_UPLOAD_CALLBACK_START_' + random;
    window[start] = function () {
      options.start && options.start(window);
    };
  }
  if (options.cancel) {
    cancel = 'APP_UPLOAD_CALLBACK_CANCEL_' + random;
    window[cancel] = function () {
      options.cancel && options.cancel(window);
    };
  }
  if (options.complete) {
    complete = 'APP_UPLOAD_CALLBACK_COMPLETE_' + random;
    window[complete] = function () {
      options.complete && options.complete(window);
    };
  }
  if (options.success) {
    success = 'APP_UPLOAD_CALLBACK_SUCCESS_' + random;
    window[success] = function (response) {
      if (options.dataType === 'json' && (typeof response === 'undefined' ? 'undefined' : _typeof(response)) !== 'object') {
        response = JSON.parse(response);
      } else if (options.dataType === 'text') {
        if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
          response = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(response);
        }
      }
      options.success && options.success.call(window, response);
    };
  }
  if (options.failure) {
    failure = 'APP_UPLOAD_CALLBACK_FAILURE_' + random;
    window[failure] = function (response) {
      if (options.dataType === 'json' && (typeof response === 'undefined' ? 'undefined' : _typeof(response)) !== 'object') {
        response = JSON.parse(response);
      } else if (options.dataType === 'text') {
        if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
          response = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(response);
        }
      }
      options.failure && options.failure.call(window, response);
    };
  }
  if (options.complete) {
    complete = 'APP_CALLBACK_COMPLETE_' + random;
    window[complete] = function () {
      options.complete && options.complete(window);
    };
  }

  var params = {
    url: options.url,
    waiting: options.waiting,
    params: j2p(options.params),
    maxwidth: options.maxwidth,
    quality: options.quality,
    start: start,
    cancel: cancel,
    success: success,
    failure: failure,
    complete: complete
  };
  this._callMethod('openUpload', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(params));
};

var statistics = void 0;
if (isApp) {
  statistics = function statistics(configs) {
    if (typeof configs === 'string') {
      return this._callMethod('webStatistics', configs);
    }
    return this._callMethod('webStatistics', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(configs));
  };
} else {
  var ma = {
    log: function log(params) {
      var args = filterArgs(params);
      jsonpRequest({
        url: 'http://analytics.108sq.cn/log/',
        params: {
          version: ma.version,
          os: getOS(),
          page: params.pageName,
          event: params.eventName,
          args: encodeURIComponent(args)
        },
        callback: 'logCallback'
      });
    },
    version: '1.0.0'
  };
  statistics = ma.log;
}

function filterArgs(params) {
  var argsObj = {};
  for (var i in params) {
    if (i !== 'pageName' && i !== 'eventName' && params.hasOwnProperty(i)) {
      argsObj[i] = params[i];
    }
  }
  var args = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(argsObj).map(function (item) {
    return item + '=' + argsObj[item];
  }).join(',');
  return args;
}

var statistics$1 = statistics;

var app = {
  _hasMethod: function _hasMethod(name) {
    return !!window['ChangShuoJSBridge'] && !!window['ChangShuoJSBridge'][name];
  },

  _callMethod: function _callMethod(name) {
    if (!this._hasMethod(name)) {
      return;
    }
    return window['ChangShuoJSBridge'][name].apply(window['ChangShuoJSBridge'], Array.prototype.slice.call(arguments).slice(1));
  },

  showWaiting: function showWaiting(sTips) {
    return this._callMethod('showWaiting', sTips);
  },

  hideWaiting: function hideWaiting() {
    return this._callMethod('hideWaiting');
  },

  showToast: function showToast(message) {
    return this._callMethod('showToast', message);
  },

  toLogin: function toLogin(isReloadOnSuccess) {
    return this._callMethod('toLogin', isReloadOnSuccess);
  },

  getToken: function getToken() {
    return this._callMethod('getToken');
  },

  getEncryptMobile: function getEncryptMobile() {
    return this._callMethod('getEncryptMobile');
  },

  getEncodeMobileFlag: function getEncodeMobileFlag() {
    return this._callMethod('getEncodeMobileFlag');
  },

  hideMoreMenu: function hideMoreMenu() {
    return this._callMethod('hideMoreMenu');
  },

  getUserId: function getUserId() {
    return this._callMethod('getUserId');
  },

  getUserName: function getUserName() {
    return this._callMethod('getUserName');
  },

  sendMessage: function sendMessage(cnt) {
    return this._callMethod('sendMessage', cnt);
  },

  shareWebPageToWeiXin: function shareWebPageToWeiXin(title, titleUrl, content, imageUrl) {
    return this._callMethod('shareWebPageToWeiXin', title, titleUrl, content, imageUrl);
  },

  shareWebPageToWeiXinFriends: function shareWebPageToWeiXinFriends(title, titleUrl, imageUrl) {
    return this._callMethod('shareWebPageToWeiXinFriends', title, titleUrl, '', imageUrl);
  },

  shareWebPage: function shareWebPage(config) {
    return this._callMethod('shareWebPage', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(config));
  },

  startNewWebView: function startNewWebView(url, param) {
    if (this._hasMethod('openWebWindow')) {
      return this._callMethod('openWebWindow', url, param);
    } else if (this._hasMethod('startNewWebView')) {
      return this._callMethod('startNewWebView', url, param);
    } else {
      window.location.href = url;
    }
  },

  openWebWindow: function openWebWindow(url, param) {
    return this._callMethod('openWebWindow', url, param);
  },

  startNewSingleWebView: function startNewSingleWebView(url, param) {
    return this._callMethod('startNewSingleWebView', url, param);
  },

  getCurrentWebViewParam: function getCurrentWebViewParam() {
    if (this._hasMethod('getWebWindowParams')) {
      return this._callMethod('getWebWindowParams');
    }
    return this._callMethod('getCurrentWebViewParam');
  },

  getWebWindowParams: function getWebWindowParams() {
    return this._callMethod('getWebWindowParams');
  },

  closeWebWindow: function closeWebWindow(config) {
    return this._callMethod('closeWebWindow', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(config));
  },

  setWebWindowName: function setWebWindowName(name) {
    return this._callMethod('setWebWindowName', name);
  },

  webStatistics: statistics$1,

  pay: function pay(payInfo, payType) {
    return this._callMethod('pay', payInfo, payType);
  },

  getSiteDomain: function getSiteDomain() {
    return this._callMethod('getSiteDomain');
  },

  ajax: ajax$1,

  openUpload: openUpload,

  openImage: function openImage(src) {
    return this._callMethod('openImage', src);
  },

  appWebShare: function appWebShare(configs) {
    return this._callMethod('appWebShare', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(configs));
  },

  openImagesWithIndex: function openImagesWithIndex(config) {
    var _defalut = {
      index: config.index || 0,
      images: config.images ? config.images.join(',') : ''
    };
    return this._callMethod('openImagesWithIndex', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(_defalut));
  },

  playVideo: function playVideo(config) {
    return this._callMethod('playVideo', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(config));
  },

  hideNavBar: function hideNavBar() {
    return this._callMethod('hideNavBar');
  },

  playAudio: function playAudio(config) {
    var _defalut = {
      url: '',
      id: '',
      title: '',
      author: '',
      type: 0,
      cb: function cb() {}
    };
    var options = {};
    for (var i in _defalut) {
      options[i] = config.hasOwnProperty(i) ? config[i] : _defalut[i];
    }
    window['APP_AUDIO_CALLBACK'] = function (response) {
      var data = typeof response === 'string' ? JSON.parse(response) : response;
      options.cb && options.cb(data);
    };
    return this._callMethod('playAudio', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(options));
  },

  changeAudioState: function changeAudioState(playing, cb) {
    var callback = cb && typeof cb === 'function' ? cb : function () {};
    window['APP_AUDIO_CALLBACK'] = function (response) {
      var data = typeof response === 'string' ? JSON.parse(response) : response;
      callback(data);
    };
    return this._callMethod('changeAudioState', playing);
  },

  getCurPlayingAudio: function getCurPlayingAudio(cb) {
    var callback = cb && typeof cb === 'function' ? cb : function () {};
    window['APP_AUDIO_CALLBACK'] = function (response) {
      var data = typeof response === 'string' ? JSON.parse(response) : response;
      callback(data);
    };
    return this._callMethod('getCurPlayingAudio');
  },

  hideRightNav: function hideRightNav(shouldHide) {
    return this._callMethod('hideRightNav', shouldHide);
  }
};

function toast(options) {
  if (typeof options === 'string' || typeof options === 'number') {
    options = {
      message: options
    };
  }
  return new Toast(options);
}

var Toast = function () {
  function Toast(options) {
    classCallCheck(this, Toast);

    this.options = {};
    this.options.message = options.message || '';
    this.options.duration = options.duration || 2000;
    this.init();
    this.createStyle();
  }

  createClass(Toast, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.dom = getInstance(this.options.message);
      document.body.appendChild(this.dom);
      setTimeout(function () {
        _this.dom.addEventListener('transitionend', _this.destroy.bind(_this));
        _this.dom.className += ' hide';
      }, this.options.duration);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      document.body.removeChild(this.dom);
      this.dom.removeEventListener('trasnitioned', this.destroy);
    }
  }, {
    key: 'createStyle',
    value: function createStyle() {
      var style = document.getElementById('_sq_toast_style');
      if (style) return;
      style = document.createElement('style');
      style.id = '_sq_toast_style';
      style.innerHTML = '\n      ._sq_toast-wrapper{\n        position:fixed;\n        left: 0;\n        bottom: 15%;\n        width:100%;\n        box-sizing: border-box;\n        text-align:center;\n        -webkit-transform: translateY(-50%);\n        transform: translateY(-50%);\n        -webkit-transition: opacity .5s;\n        transition: opacity .5s;\n        z-index: 999;\n      }\n      ._sq_toast-wrapper.hide{\n        opacity: 0;\n      }\n      ._sq_toast--main{\n        display: inline-block;\n        background: rgba(0,0,0,.4);\n        color: #fff;\n        font-size: 14px;\n        padding: 4px 10px;\n        border-radius: 99px;\n        word-break: break-all;\n        box-sizing: border-box;\n        max-width: 60%;\n        text-align: center;\n      }\n    ';
      document.head.appendChild(style);
    }
  }]);
  return Toast;
}();

function getInstance(message) {
  var instance = document.createElement('div');
  instance.className = '_sq_toast-wrapper';
  var toast = document.createElement('div');
  toast.className = '_sq_toast--main';
  toast.innerText = message;
  instance.appendChild(toast);
  return instance;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  isAndroid: isAndroid,
  isIPhone: isIPhone,
  isPCDebug: false,
  appInfo: appInfo,
  hosts: hosts,
  app: app,
  toast: toast
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parsePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_hhkjsq_js__ = __webpack_require__(5);

var hosts = __WEBPACK_IMPORTED_MODULE_0__common_hhkjsq_js__["a" /* default */].hosts;

var emotions = ['爱你', '傲慢', '抱抱', '鄙视', '闭嘴', '打哈哈', '鼓掌', '哈哈', '哈欠', '害羞', '好困', '好色', '黑线', '加油', '可爱', '可怜', '酷', '狂晕', '流泪', '怒骂', '钱', '偷笑', '吐', '挖鼻屎', '委屈', '我打', '嘻嘻', '小丑', '嘘', '晕', '再见', '左哼哼', '爱心传递', '蜡烛', '赞', '差', '互粉', '伤心', '给力', '围观', '小八打招呼', '小八卖萌', '小八馋嘴', '小八捏脸', '小八惊吓', '小八擦汗', '小八美梦', '小八花痴', '小八石化', '小八犯困', '小八委屈', '小八大哭', '小八发火', '小八怒骂', '小八得意', '小八白眼', '小八奋斗', '小八抠鼻', '小八赞', '小八傲慢', '小八闭嘴', '小八调皮', '小八饿', '小八通知', '小八咧嘴', '小八撇嘴', '小八亲', '小八生日', '小八衰', '小八偷笑', '小八吓', '小八嘘', '小八疑问', '小八晕倒', '小八抓狂', '小八耶'];

var url = {
  emotion: function emotion(name) {
    return hosts.shuocdn + '/frontEnd/external/TCSay/emotion/default/' + (emotions.indexOf(name) + 1) + '.gif';
  }
};

var ubb = {
  link: {
    regStart: /\[link([^\]]+)?\]/g,
    regEnd: /\[\/link\]/g,
    replace: function replace(sText, isRemoveStyle) {
      var self = this;
      if (isRemoveStyle) {
        return self.remove(sText);
      }
      return sText.replace(self.regStart, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/href="([^"]+)"/, function (sMatch, sSub) {
          var h = decodeURIComponent(sSub),
              l = Talk.parseWapLink(h);
          return ['href="', l, '"'].join('');
        });
        sSub = !sSub ? '' : sSub.replace(/target="([^"]+)"/, function (sMatch, sSub) {
          return '';
        });
        sSub = !sSub ? '' : sSub.replace(/style="([^"]+)"/g, function (sMatch, sSub) {
          return ['style="', sSub.replace(/＃/g, '#'), '"'].join('');
        });
        return ['<a', sSub, '>'].join('');
      }).replace(self.regEnd, '<\/a>');
    },
    remove: function remove(sText) {
      return sText.replace(this.regStart, '').replace(this.regEnd, '');
    }
  },
  font: {
    regStart: /\[span([^\]]+?)?\]/g,
    regEnd: /\[\/span\]/g,
    replace: function replace(sText, isRemoveStyle) {
      var self = this;
      if (isRemoveStyle) {
        return self.remove(sText);
      }
      return sText.replace(self.regStart, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/style="(.+)"/g, function (sMatch, sSub) {
          return ['style="', sSub.replace(/＃/g, '#'), '"'].join('');
        });
        return ['<span', sSub, '>'].join('');
      }).replace(self.regEnd, '<\/span>');
    },
    remove: function remove(sText) {
      return sText.replace(this.regStart, '').replace(this.regEnd, '');
    }
  },
  p: {
    regStart: /\[p([^\]]+?)?\]/g,
    regEnd: /\[\/p\]/g,
    replace: function replace(sText, isRemoveStyle) {
      var self = this;
      if (isRemoveStyle) {
        return self.remove(sText);
      }
      return sText.replace(self.regStart, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/style="(.+)"/g, function (sMatch, sSub) {
          return ['style="', sSub.replace(/＃/g, '#'), '"'].join('');
        });
        return ['<p', sSub, '>'].join('');
      }).replace(self.regEnd, '<\/p>');
    },
    remove: function remove(sText) {
      return sText.replace(this.regStart, '').replace(this.regEnd, '');
    }
  },
  br: {
    reg: /\[br(\/)?\]/g,
    replace: function replace(sText, isRemove) {
      return sText.replace(this.reg, isRemove ? '' : '<br>');
    },
    remove: function remove(sText) {
      return this.replace(sText, true);
    }
  },
  img: {
    reg: /\[img([^\]]+?)?\]/g,
    replace: function replace(sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '');
      }
      return sText.replace(this.reg, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/src="([^\"\']+)"/g, function (sMatch, sSub) {
          var sSub = unescape(sSub);
          if (!/^http:\/\//.test(sSub)) {
            sSub = Talk.HOST_SHOWIMG + sSub;
          }
          return ['src="', sSub, '"'].join('');
        });
        return ['<img', sSub, '\/>'].join('');
      });
    },
    remove: function remove(sText) {
      return this.replace(sText, true);
    }
  },
  video: {
    reg: /\[video([^\[\]]+)\]/g,
    replace: function replace(sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '');
      }
      return sText.replace(this.reg, function (sMatch, sSub) {
        sSub = !sSub ? '' : sSub.replace(/src="([^\"\']+)"/g, function (sMatch, sSub) {
          var sSub = unescape(sSub);
          return ['data-videoSrc="', sSub, '"'].join('');
        }).replace(/width="([0-9]*)"/g, function (sMatch, sSub) {
          return ['data-width="', sSub, '"'].join('');
        }).replace(/height="([0-9]*)"/g, function (sMatch, sSub) {
          return ['data-height="', sSub, '"'].join('');
        });
        var videoImg = params.arrImg.shift();
        var str = '  data-videoImg="' + videoImg[0] + '"';
        return ['<span class="video" ', sSub, str, '\/><img src="', videoImg[0], '"/><span class="playVideo"></span></span>'].join('');
      });
    },
    remove: function remove(sText) {
      return this.replace(sText, true);
    }
  },
  topic: {
    reg: /(#([^#]+)#)/g,
    replace: function replace(sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '');
      }
    },
    remove: function remove(sText) {
      return this.replace(sText, true);
    }
  },
  mention: {
    reg: /(@([^@\s,:：;；,，\[\]]{1,16}?))([\s,:：;；,，\[\]]|$)/g,
    replace: function replace(sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '');
      }
    },
    remove: function remove(sText) {
      return this.replace(sText, true);
    }
  },
  picSymbol: {
    reg: /\[图片\d*\]/g,
    replace: function replace(sText, isRemove) {
      if (isRemove) {
        return sText.replace(this.reg, '');
      }
    },
    remove: function remove(sText) {
      return this.replace(sText, true);
    }
  },
  getCleanText: function getCleanText(sText) {
    var self = this;
    sText = self.p.remove(sText);
    sText = self.link.remove(sText);
    sText = self.font.remove(sText);
    sText = self.br.remove(sText);
    sText = self.img.remove(sText);
    sText = self.video.remove(sText);
    sText = self.topic.remove(sText);
    sText = self.mention.remove(sText);
    sText = self.picSymbol.remove(sText);
    return sText;
  }
};

var parseVideo = function parseVideo(content) {
  var exp = /\[video([^\[\]]+)\]/g;
  var result = exp.exec(content);
  if (result) {
    var srcReg = /src="([^\"\']+)"/g;
    var src = srcReg.exec(result[1]);
    return src[1];
  }
  return false;
};

var parsePost = function parsePost(content, ishost) {
  var exp = /\[post\sid=["|']([^\]]+)["|']\]/;
  var result = exp.exec(content);
  if (result && ishost) {
    return result[1] || false;
  }
  return false;
};

function filterPostContent(content, postId) {
  content = ubb.getCleanText(content);
  return content;
}

var parseContent = function parseContent(content, postId) {
  try {
    content = decodeURIComponent(content);
  } catch (e) {
    console.log("filter:js decodeURIComponent content error");
  }

  content = content.replace(/<\/*[a-zA-Z]+[^>]*>/g, '');

  content = content.replace(/\[video[^[\]]+\]/g, '');

  var length = content.length;

  content = content.replace(/\s?(\/([\u4e00-\u9fa5]+)\/)\s?/g, function () {
    if (emotions.indexOf(arguments[2]) > -1) {
      return '<img src="' + url.emotion(arguments[2]) + '" class="emotion">';
    }
    return arguments[1];
  });

  content = content.replace(/\[post[^[\]]+\]/g, '加载帖子中');

  if (postId) {
    content = filterPostContent(content, postId);
  }

  return {
    content: content,
    length: length
  };
};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = initAllList2;
/* harmony export (immutable) */ __webpack_exports__["e"] = initEliteList2;
/* unused harmony export initAllList */
/* unused harmony export initEliteList */
/* unused harmony export getMoreAllList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getMoreAllList2; });
/* unused harmony export pubComment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pubComment2; });
/* unused harmony export pubPraise */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pubPraise2; });
/* unused harmony export getPostInfo */
/* harmony export (immutable) */ __webpack_exports__["g"] = getPostInfo2;
/* unused harmony export delPraise */
/* harmony export (immutable) */ __webpack_exports__["i"] = delPraise2;
/* unused harmony export getPraiseInfoList */
/* harmony export (immutable) */ __webpack_exports__["d"] = getPraiseInfoList2;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUserHeadUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserHomeUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zepto__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zepto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_zepto__);





var appInfo = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].appInfo,
    isAndroid = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].isAndroid,
    isIPhone = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].isIPhone,
    app = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].app;

var DEFAULT_PAGE_SIZE = 30;

var DEFAULT_INFO_TYPE = 2031;

var DEFAULT_POSITION_ID = 0;

var DEFAULT_ORDER_BY = 3;

var DEFAULT_INIT_PADE_INDEX = 1;

var DEFAULT_CITY_ID = 2;

function getSource() {
  if (isAndroid) {
    return 4;
  } else if (isIPhone) {
    return 5;
  }
}

function fetchFactory(url) {
  var getRequestData = function getRequestData(data) {
    return {
      infoID: data.infoID,
      infoType: data.infoType || DEFAULT_INFO_TYPE,
      pageIndex: data.pageIndex || DEFAULT_INIT_PADE_INDEX,
      pageSize: data.pageSize || DEFAULT_PAGE_SIZE,
      positionID: data.positionID || DEFAULT_POSITION_ID,
      orderBy: data.orderBy || DEFAULT_ORDER_BY
    };
  };
  return function (params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["b" /* fetch */])({
      url: url,
      data: getRequestData(params),
      dataType: 'jsonp'
    })();
  };
}

function initAllList2(options) {
  options.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
    infoType: DEFAULT_INFO_TYPE,
    pageIndex: DEFAULT_INIT_PADE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    positionID: DEFAULT_POSITION_ID,
    orderBy: DEFAULT_ORDER_BY
  }, options.params);
  options.url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_ALL_COMMENT_LIST;
  getJsonp(options);
}

function initEliteList2(options) {
  options.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
    infoType: DEFAULT_INFO_TYPE,
    pageIndex: DEFAULT_INIT_PADE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    positionID: DEFAULT_POSITION_ID,
    orderBy: DEFAULT_ORDER_BY
  }, options.params);
  options.url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_ELITE_COMMENT_LIST;
  getJsonp(options);
}

var initAllList = fetchFactory(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_ALL_COMMENT_LIST);

var initEliteList = fetchFactory(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_ELITE_COMMENT_LIST);

var getMoreAllList = function getMoreAllList(params) {
  var defaultParams = {
    infoType: DEFAULT_INFO_TYPE,
    topNum: DEFAULT_PAGE_SIZE,
    minCommentId: 0,
    maxCommentId: 0
  };
  params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultParams, params);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["b" /* fetch */])({
    url: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_TOP_NUM_COMMENT_LIST,
    data: params,
    dataType: 'jsonp'
  })();
};

var getMoreAllList2 = function getMoreAllList2(options) {
  var defaultParams = {
    infoType: DEFAULT_INFO_TYPE,
    topNum: DEFAULT_PAGE_SIZE,
    minCommentId: 0,
    maxCommentId: 0
  };
  options.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultParams, options.params);
  options.url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_TOP_NUM_COMMENT_LIST;
  getJsonp(options);
};

var pubComment = function pubComment(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["j" /* fetchAjax */])({
    url: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].POST_COMMENT,
    type: 'POST',
    data: {
      InfoID: params.InfoID,
      infoType: DEFAULT_INFO_TYPE,
      ComTxt: params.ComTxt,
      InfoMemo: params.InfoMemo || '',
      TopicUserName: params.TopicUserName,
      UserID: params.UserID,
      PreCommentID: params.PreCommentID,
      Source: getSource(),
      WebSiteID: appInfo.cityId || DEFAULT_CITY_ID,
      ImagePath: params.ImagePath || ''
    }
  })();
};

var pubComment2 = function pubComment2(options) {
  options.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
    infoType: DEFAULT_INFO_TYPE,
    InfoMemo: '空',
    Source: getSource(),
    WebSiteID: appInfo.cityId || DEFAULT_CITY_ID,
    ImagePath: ''
  }, options.params);
  options.type = 'POST';
  options.url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].POST_COMMENT;
  options.isNeedDecode = true;
  appAjax(options);
};

function appAjax(options) {
  app.ajax({
    url: options.url,
    params: options.params,
    type: options.type || 'GET',
    isNeedDecode: options.isNeedDecode || false,
    success: function success(response) {
      options.success && options.success(response);
    },
    error: function error(_error) {
      options.error && options.error(_error);
    },
    complete: function complete() {
      options.complete && options.complete();
    }
  });
}

function getJsonp(options) {
  __WEBPACK_IMPORTED_MODULE_4_zepto___default.a.ajax({
    url: options.url,
    data: options.params,
    dataType: 'jsonp',
    success: function success(response) {
      options.success && options.success(response);
    },
    error: function error(_error2) {
      options.error && options.error(_error2);
    },
    complete: function complete() {
      options.complete && options.complete();
    }
  });
}

var pubPraise = function pubPraise(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["j" /* fetchAjax */])({
    url: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].POST_PRAISE,
    type: 'POST',
    data: {
      InfoID: params.InfoID,
      InfoType: DEFAULT_INFO_TYPE,
      InfoMemo: params.InfoMemo || '',
      TopicUserName: params.TopicUserName,
      TopicUserID: params.TopicUserID || 0,
      Source: getSource()
    }
  })();
};

var pubPraise2 = function pubPraise2(options) {
  options.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
    InfoType: DEFAULT_INFO_TYPE,
    InfoMemo: '空',
    TopicUserID: 0,
    Source: getSource()
  }, options.params);
  options.type = 'POST';
  options.url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].POST_PRAISE;
  appAjax(options);
};

var getPostInfo = function getPostInfo(_ref) {
  var id = _ref.id;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["b" /* fetch */])({
    url: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_POST_BY_ID,
    type: 'GET',
    dataType: 'jsonp',
    data: {
      id: id
    }
  })();
};

function getPostInfo2(options) {
  options.url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_POST_BY_ID;
  getJsonp(options);
}

var delPraise = function delPraise(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["j" /* fetchAjax */])({
    url: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].DEL_PRAISE_INFO,
    type: 'GET',
    data: {
      InfoType: DEFAULT_INFO_TYPE,
      InfoID: params.InfoID
    }
  })();
};

function delPraise2(options) {
  options.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
    InfoType: DEFAULT_INFO_TYPE
  }, options.params);
  options.url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].DEL_PRAISE_INFO;
  appAjax(options);
}

var getPraiseInfoList = function getPraiseInfoList(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["j" /* fetchAjax */])({
    url: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].PRAISE_LIST,
    type: 'GET',
    data: {
      InfoType: DEFAULT_INFO_TYPE,
      InfoIDs: params.InfoIDs
    }
  })();
};

function getPraiseInfoList2(options) {
  options.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
    InfoType: DEFAULT_INFO_TYPE
  }, options.params);
  options.url = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].PRAISE_LIST;
  appAjax(options);
}

var getUserHeadUrl = function getUserHeadUrl(id) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_HEAD_PIC(id);
};

var getUserHomeUrl = function getUserHomeUrl(name) {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].GET_USER_HOME(name);
};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_hhkjsq_js__ = __webpack_require__(5);

var hosts = __WEBPACK_IMPORTED_MODULE_0__common_hhkjsq_js__["a" /* default */].hosts;

/* harmony default export */ __webpack_exports__["a"] = ({
  GET_PAGE_INFO: function GET_PAGE_INFO(id) {
    return hosts.common + '/Html/Live/Infos/' + id + '.json';
  },
  GET_ALL_COMMENT_LIST: hosts.discuss1 + '/API/AComment/CommentList',
  GET_ELITE_COMMENT_LIST: hosts.discuss1 + '/API/AComment/CommentTopList',
  GET_TOP_NUM_COMMENT_LIST: hosts.discuss1 + '/API/AComment/GetCommentListForTopNum',
  PUB_COMMENT: hosts.discuss1 + '/API/AComment/PubComment',
  POST_COMMENT: hosts.discuss1 + '/API/AComment/PostComment',
  POST_PRAISE: hosts.userop + '/API/APraise/PostPraise',
  PUB_PRAISE: hosts.userop + '/API/APraise/PubPraise',
  DEL_PRAISE_INFO: hosts.userop + '/API/APraise/DelPraiseInfo',
  PRAISE_LIST: hosts.userop + '/API/APraise/PraiseInfo',
  GET_POST_BY_ID: hosts.mtalksvcv2 + '/api/info/getById',
  GET_HEAD_PIC: function GET_HEAD_PIC(id) {
    return hosts.usertxcdn + '/info/getheadpic?id=' + id;
  },
  GET_USER_HOME: function GET_USER_HOME(name) {
    return hosts.main + '/userweb/' + name;
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var upmovinginContext = '@@upmovinginContext';
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var documentHandler = function documentHandler(e) {
      if (el[upmovinginContext].dispatched) {
        document.removeEventListener('srcoll', el[upmovinginContext].documentHandler);
        return;
      }
      var elRect = el.getBoundingClientRect();
      var elTop = elRect.top;

      var vHeight = window.innerHeight;
      if (elTop > 0 && elTop < vHeight) {
        if (binding.expression) {
          vnode.context[el[upmovinginContext].methodName](e);
        } else {
          el[upmovinginContext].bindingFn(e);
        }
        el[upmovinginContext].dispatched = true;
      }
    };

    el[upmovinginContext] = {
      documentHandler: documentHandler,
      methodName: binding.expression,
      bindingFn: binding.value,
      dispatched: false
    };
    document.addEventListener('scroll', el[upmovinginContext].documentHandler);
  },
  unbind: function unbind(el) {
    document.removeEventListener('scroll', el[upmovinginContext].documentHandler);
  },
  inserted: function inserted(el) {
    el[upmovinginContext].documentHandler();
  }
});

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

module.exports = Zepto;

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    vnode['context'].documentHandler = function (e) {
      if (el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        vnode['context'][binding.expression]();
      }
    };
    document.addEventListener('click', vnode['context'].documentHandler);
  },
  unbind: function unbind(el, binding, vnode) {
    document.removeEventListener('click', vnode['context'].documentHandler);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__module_list__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module_header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module_swipe__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__module_comment__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__module_share__ = __webpack_require__(108);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);






var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    list: __WEBPACK_IMPORTED_MODULE_2__module_list__["a" /* default */],
    header: __WEBPACK_IMPORTED_MODULE_3__module_header__["a" /* default */],
    swipe: __WEBPACK_IMPORTED_MODULE_4__module_swipe__["a" /* default */],
    comment: __WEBPACK_IMPORTED_MODULE_5__module_comment__["a" /* default */],
    share: __WEBPACK_IMPORTED_MODULE_6__module_share__["a" /* default */]
  },
  state: {
    loadmore: true
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(209),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_content__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_content_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_content_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_footer__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footer_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_swipe_swipe__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_swipe_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_swipe_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer_commentArea__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer_commentArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_footer_commentArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_funcButtons_funcButtons__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_funcButtons_funcButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_funcButtons_funcButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_share_share__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_share_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_share_share__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    'sq-header': __WEBPACK_IMPORTED_MODULE_0__components_header_header___default.a,
    'sq-content': __WEBPACK_IMPORTED_MODULE_1__components_content_content___default.a,
    'sq-footer': __WEBPACK_IMPORTED_MODULE_2__components_footer_footer___default.a,
    'sq-swipe': __WEBPACK_IMPORTED_MODULE_3__components_swipe_swipe___default.a,
    'sq-comment-area': __WEBPACK_IMPORTED_MODULE_4__components_footer_commentArea___default.a,
    'sq-func-buttons': __WEBPACK_IMPORTED_MODULE_5__components_funcButtons_funcButtons___default.a,
    'sq-share': __WEBPACK_IMPORTED_MODULE_6__components_share_share___default.a
  },

  mounted: function mounted() {
    this.$store.dispatch('getPageInfo');
  },


  computed: {
    swipe: function swipe() {
      return this.$store.state.swipe;
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardItem__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cardItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_filter__ = __webpack_require__(29);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'card-item': __WEBPACK_IMPORTED_MODULE_1__cardItem___default.a
  },

  props: {
    data: {
      type: Object
    },
    isInCard: {
      type: Boolean
    },
    showDate: {
      type: Boolean
    }
  },

  computed: {
    isHost: function isHost() {
      return this.data.TopicUserName === this.data.UserName;
    },
    postId: function postId() {
      if (this.isHost) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_filter__["c" /* parsePost */])(this.data.CommentContent, this.isHost);
      }
      return false;
    },
    isPost: function isPost() {
      if (this.postId) {
        this.$store.dispatch('getPostInfo', {
          id: this.postId,
          data: this.data
        });
        return true;
      }
      return false;
    },
    postInfo: function postInfo() {
      var postInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data, this.$store.state.list.postInfo[this.postId]);
      return postInfo;
    },
    favoredCount: function favoredCount() {
      var praiseInfo = this.$store.state.list.praiseCountList;
      if (praiseInfo[this.data.CommentID]) {
        return praiseInfo[this.data.CommentID].count;
      }
      return undefined;
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_img_adaptImg__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_img_adaptImg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_img_adaptImg__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'sq-img': __WEBPACK_IMPORTED_MODULE_1__components_img_adaptImg___default.a
  },
  data: function data() {
    return {
      preload: __WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png___default.a
    };
  },


  props: {
    imgs: {
      type: Array
    }
  },

  computed: {
    imgsClassName: function imgsClassName() {
      var count = 1;
      if (this.imgs.length >= 2) {
        count = 3;
      } else {
        count = this.imgs.length;
      }
      return 'm-card-imgs--' + count;
    }
  },

  methods: {
    showSwipe: function showSwipe(index) {
      this.$store.dispatch('initSwipe', { imgs: this.imgs, index: index });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardImages__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardImages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cardImages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardVideo__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cardVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_filter__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_hhkjsq_js__ = __webpack_require__(5);










var hosts = __WEBPACK_IMPORTED_MODULE_5__common_hhkjsq_js__["a" /* default */].hosts;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'sq-card-images': __WEBPACK_IMPORTED_MODULE_1__cardImages___default.a,
    'sq-card-video': __WEBPACK_IMPORTED_MODULE_2__cardVideo___default.a
  },

  data: function data() {
    return {
      openAllShow: true
    };
  },


  props: {
    data: {
      type: Object
    },
    isInCard: {
      type: Boolean
    },
    showDate: {
      type: Boolean
    }
  },

  computed: {
    postHref: function postHref() {
      return hosts.nodomain + '/shuo/detail/' + this.data.PostID;
    },
    imgLists: function imgLists() {
      if (this.data.ImagePath) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_index__["e" /* imgStr2Arr */])(this.data.ImagePath);
      }
      return [];
    },
    videoSrc: function videoSrc() {
      if (!this.data.IsPost && this.data.UserName !== (this.data.TopicUserName || this.$store.state.header.PrensenterName)) {
        return null;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["b" /* parseVideo */])(this.data.CommentContent);
    },
    isFavored: function isFavored() {
      var praiseInfo = this.$store.state.list.praiseCountList;
      if (praiseInfo[this.data.CommentID]) {
        return !praiseInfo[this.data.CommentID].isShow;
      }
      return false;
    },
    isHost: function isHost() {
      return this.data.TopicUserName === this.data.UserName;
    },
    favoredCount: function favoredCount() {
      var praiseInfo = this.$store.state.list.praiseCountList;
      if (praiseInfo[this.data.CommentID]) {
        return praiseInfo[this.data.CommentID].count;
      }
      return undefined;
    },
    filteredContent: function filteredContent() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["a" /* parseContent */])(this.data.CommentContent, this.data.PostID).content;
    },
    filteredContentLength: function filteredContentLength() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_filter__["a" /* parseContent */])(this.data.CommentContent, this.data.PostID).length;
    }
  },

  methods: {
    parseContent: __WEBPACK_IMPORTED_MODULE_3__utils_filter__["a" /* parseContent */],
    parseVideo: __WEBPACK_IMPORTED_MODULE_3__utils_filter__["b" /* parseVideo */],
    imgStr2Arr: __WEBPACK_IMPORTED_MODULE_4__utils_index__["e" /* imgStr2Arr */],
    reply: function reply() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_index__["c" /* inOtherBroswer */])()) return;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_index__["d" /* isLogin */])()) {
        var preCommentInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.data, { PreCommentInfo: null });
        var preComment = {
          preCommentID: this.data.CommentID,
          preCommentInfo: preCommentInfo
        };
        this.$store.dispatch('showCommentArea', preComment);
      }
    },
    handlePraise: function handlePraise() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_index__["c" /* inOtherBroswer */])()) return;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_index__["d" /* isLogin */])()) {
        this.$store.dispatch('handlePraise', this.data);
      }
    },
    openAll: function openAll() {
      this.openAllShow = false;
    },
    closeAll: function closeAll() {
      this.openAllShow = true;
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_pause_png__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_pause_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_icons_pause_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_del_png__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_del_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_del_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_hhkjsq_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directive_onceScrollInView__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directive_scrollOutView__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_loading_gif__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_loading_gif__);










var isAndroid = __WEBPACK_IMPORTED_MODULE_2__common_hhkjsq_js__["a" /* default */].isAndroid,
    isIPhone = __WEBPACK_IMPORTED_MODULE_2__common_hhkjsq_js__["a" /* default */].isIPhone;

/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    scrollInViewOnce: __WEBPACK_IMPORTED_MODULE_3__directive_onceScrollInView__["a" /* default */],
    scrollOutView: __WEBPACK_IMPORTED_MODULE_4__directive_scrollOutView__["a" /* default */]
  },
  props: ['src'],
  data: function data() {
    return {
      paused: true,
      ended: false,
      beforePlay: false,
      duration: 0,
      presrc: '',
      error: false,
      icons: {
        pause: __WEBPACK_IMPORTED_MODULE_0__assets_icons_pause_png___default.a,
        del: __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_del_png___default.a
      },
      isAndroid: isAndroid,
      isIPhone: isIPhone,
      canvasSupported: __WEBPACK_IMPORTED_MODULE_5__utils_index__["f" /* canvasSupported */],
      videoLoaded: false,
      loading: __WEBPACK_IMPORTED_MODULE_6__assets_images_loading_gif___default.a
    };
  },

  methods: {
    play: function play() {
      this.beforePlay = false;
      if (this.paused || this.ended) {
        this.paused = false;
        this.ended = false;
        this.$refs.video.currentTime = 0;
        return this.$refs.video.play();
      }
      this.paused = true;
      return this.$refs.video.pause();
    },
    handleDuration: function handleDuration(time) {
      if (!time || time === Infinity || time <= 1) {
        return false;
      }
      var dura = Math.floor(Number(time));
      var min = Math.floor(dura / 60);
      var sec = dura - min * 60;
      min = min <= 9 ? '0' + min : min;
      sec = sec <= 9 ? '0' + sec : sec;
      return [min, sec].join(':');
    },
    scrollIn: function scrollIn() {
      var _this = this;

      this.presrc = this.src;
      this.$refs.video.addEventListener('loadedmetadata', function () {
        _this.duration = _this.handleDuration(_this.$refs.video.duration);
      });
      this.$refs.video.addEventListener('error', function () {
        _this.error = true;
      });
      this.$refs.video.addEventListener('loadeddata', function () {
        _this.videoLoaded = true;
        if (isIPhone) {
          return;
        }
        _this.drawFirstFrame();
      });
      this.$refs.video.addEventListener('ended', function () {
        _this.ended = true;
      });
      if (isIPhone) {
        this.videoLoaded = true;
        this.drawFirstFrame();
      }
    },
    reload: function reload() {
      this.error = false;
      this.ended = false;
      this.videoLoaded = false;
      this.presrc = this.src;
      this.$refs.video.src = this.src;
    },
    scrollOut: function scrollOut() {
      this.paused = true;
      this.$refs.video.pause();
    },
    drawFirstFrame: function drawFirstFrame() {
      if (this.beforePlay) {
        this.beforePlay = false;
        return;
      }
      var canvas = this.$refs.canvas;
      var video = this.$refs.video;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.beforePlay = true;
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_filter__ = __webpack_require__(29);



/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    parseContent: __WEBPACK_IMPORTED_MODULE_0__utils_filter__["a" /* parseContent */]
  },

  computed: {
    commentContent: function commentContent() {
      var content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_filter__["a" /* parseContent */])(this.data.CommentContent).content;
      if (content.length === 0) {
        var imgs = this.data.ImagePath.length > 0 ? this.data.ImagePath.split('|') : [];
        if (this.data.UserName === (this.data.TopicUserName || this.PrensenterName) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_filter__["b" /* parseVideo */])(this.data.CommentContent)) {
          content += '[视频]';
        } else {
          imgs.forEach(function () {
            content += '[图片]';
          });
        }
      }
      return content;
    },
    PrensenterName: function PrensenterName() {
      return this.$store.state.header.pageInfo.PrensenterName;
    }
  },

  props: {
    data: {
      type: Object
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__live__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__live___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__live__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__nav__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'sq-live': __WEBPACK_IMPORTED_MODULE_0__live___default.a,
    'sq-nav': __WEBPACK_IMPORTED_MODULE_1__nav___default.a
  },

  data: function data() {
    return {
      allId: 'all',
      eliteId: 'elite'
    };
  },


  methods: {
    changeActive: function changeActive(name) {
      this.active = name;
    },
    allTop: function allTop(callback) {
      this.$store.dispatch('reload', callback);
    },
    allBottom: function allBottom() {
      this.$store.dispatch('getMoreAllBottomList');
    },
    eliteTop: function eliteTop(callback) {
      this.$store.dispatch('reload', callback);
    },
    eliteBottom: function eliteBottom() {
      this.$store.dispatch('getEliteMoreInfo');
    },
    onscroll: function onscroll(e) {
      var isBottom = document.body.clientHeight <= window.scrollY + window.innerHeight + 100;
      if (isBottom) {
        this.onBottomLoad();
      }
    },
    onBottomLoad: function onBottomLoad() {
      if (this.active === this.allId && this.allList.list.length > 0) {
        this.allBottom();
      }
      if (this.active === this.eliteId && this.eliteList.list.length > 0) {
        this.eliteBottom();
      }
    }
  },

  computed: {
    headerInfo: function headerInfo() {
      return this.$store.state.header;
    },
    allList: function allList() {
      console.log(this.$store.state.list.all);
      return this.$store.state.list.all;
    },
    eliteList: function eliteList() {
      return this.$store.state.list.elite;
    },
    active: function active() {
      return this.$store.state.list.activeId;
    }
  },

  mounted: function mounted() {
    document.addEventListener('scroll', this.onscroll, false);
    document.addEventListener('touchmove', this.onscroll, false);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timeline_timeline__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timeline_timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__timeline_timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeline_timelineItem__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeline_timelineItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__timeline_timelineItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_card__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__card_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__card_incard__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__card_incard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__card_incard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loadmore__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loadmore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loadmore__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'sq-timeline': __WEBPACK_IMPORTED_MODULE_0__timeline_timeline___default.a,
    'sq-timeline-item': __WEBPACK_IMPORTED_MODULE_1__timeline_timelineItem___default.a,
    'sq-card': __WEBPACK_IMPORTED_MODULE_2__card_card___default.a,
    'sq-card-incard': __WEBPACK_IMPORTED_MODULE_3__card_incard___default.a,
    'sq-loadmore': __WEBPACK_IMPORTED_MODULE_4__loadmore___default.a
  },

  props: {
    data: {
      type: Array
    },
    topFunc: {
      type: Function
    }
  },

  methods: {
    topMethod: function topMethod(callback) {
      this.topFunc(callback);
    },
    showDate: function showDate(i, type) {
      if (i === 0) {
        return true;
      }
      var cur = new Date(this.data[i].CreateTimeToInt * 1000);
      var prev = new Date(this.data[i - 1].CreateTimeToInt * 1000);
      if (cur.getFullYear() === prev.getFullYear() && cur.getMonth() === prev.getMonth() && cur.getDate() === prev.getDate() && type === 'year') {
        return false;
      }

      if (cur.getHours() === prev.getHours() && cur.getMinutes() === prev.getMinutes() && type === 'date') {
        return false;
      }
      return true;
    },
    formateDate: function formateDate(timestamp, type) {
      var time = new Date(timestamp * 1000);
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      var hh = time.getHours();
      var mm = time.getMinutes();
      hh = hh <= 9 ? '0' + hh : hh;
      mm = mm <= 9 ? '0' + mm : mm;
      if (type === 'year') {
        return [year, month, date].join('-');
      }
      if (type === 'date') {
        return [hh, mm].join(':');
      }
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pulldown__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pulldown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pulldown__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'pulldown': __WEBPACK_IMPORTED_MODULE_0__pulldown___default.a
  },
  data: function data() {
    return {
      topStatus: ''
    };
  },


  props: {
    'topMethod': {
      type: Function
    },
    'bottomMethod': {
      type: Function
    }
  },

  methods: {
    topLoadMore: function topLoadMore() {
      this.topMethod(this.$refs.reflash.onloaded);
    },
    handleTopChange: function handleTopChange(status) {
      this.topStatus = status;
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      allId: 'all',
      eliteId: 'elite',
      isOutofView: false,
      scrollTop: {
        all: 0,
        elite: 0
      }
    };
  },


  computed: {
    headerHeight: function headerHeight() {
      var ratio = this.$store.state.header.ratio;
      var height = ratio * document.body.clientWidth;
      return height;
    }
  },

  props: ['activeId'],

  methods: {
    initEliteList: function initEliteList(id) {
      if (id === this.allId || this.$store.state.list.elite.inited) {
        return;
      }
      this.$store.dispatch('initEliteList');
    },
    initScrollTop: function initScrollTop() {
      this.scrollTop.all = this.scrollTop.all === 0 ? this.headerHeight : this.scrollTop.all;
      this.scrollTop.elite = this.scrollTop.elite === 0 ? this.headerHeight : this.scrollTop.elite;
    },
    changeActive: function changeActive(id) {
      var _this = this;

      if (id === this.allId) {
        this.scrollTop.elite = document.body.scrollTop;
      } else {
        this.scrollTop.all = document.body.scrollTop;
      }

      var rect = this.$refs.nav.getBoundingClientRect();
      if (rect.top <= 0) {
        window.setTimeout(function () {
          window.scrollTo(0, Math.max(_this.scrollTop[id], _this.headerHeight));
        }, 0);
      }

      this.$store.dispatch('handleTimer', {
        oldId: this.activeId,
        newId: id
      });
      this.$store.dispatch('changActiveId', id);
      this.initEliteList(id);
    },
    bindScrollEvent: function bindScrollEvent() {
      var _this2 = this;

      var onscroll = function onscroll(e) {
        var rect = _this2.$refs.nav.getBoundingClientRect();
        if (rect.top < 0) {
          _this2.isOutofView = true;
        } else {
          _this2.isOutofView = false;
        }
      };
      window.addEventListener('scroll', onscroll, false);
      window.addEventListener('resize', onscroll, false);
    }
  },

  mounted: function mounted() {
    this.bindScrollEvent();
    this.initScrollTop();
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    topMethod: {
      type: Function
    }
  },
  data: function data() {
    return {
      transition: 'none',
      translate: 0,
      startY: 0,
      currentY: 0,
      opacity: 0,
      istriggered: false,
      status: 'pull',
      touching: false
    };
  },
  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      this.$el.addEventListener('touchstart', this.ontouchstart);
      this.$el.addEventListener('touchmove', this.ontouchmove, false);
      this.$el.addEventListener('touchend', this.ontouchend);
    },
    ontouchstart: function ontouchstart(e) {
      if (this.touching) {
        return;
      }
      this.startY = e.touches[0].clientY;
      this.touching = true;
    },
    ontouchmove: function ontouchmove(e) {
      if (this.startY < this.$el.getBoundingClientRect().top) {
        return;
      }
      this.currentY = e.touches[0].clientY;
      var distance = this.currentY - this.startY;
      var scrollTop = document.body.scrollTop;
      if (distance < 0 || scrollTop !== 0) {
        return;
      }
      this.transition = 'none';
      this.status = 'pulling';
      if (this.status === 'pulling') {}
      var max = 80;
      var min = 60;
      this.translate = Math.min(distance / 2, max);
      this.opacity = this.translate > min ? 1 : this.translate / max;
      this.istriggered = this.translate >= min;
    },
    ontouchend: function ontouchend(e) {
      if (this.istriggered) {
        this.topMethod && this.topMethod();
      } else {
        this.onloaded();
      }
      this.touching = false;
    },
    onloaded: function onloaded() {
      this.transition = 'transform .2s';
      this.translate = 0;
      this.opacity = 0;
      this.status = 'pull';
      this.istriggered = false;
    }
  },

  computed: {
    dpr: function dpr() {
      var i = 0;
      var p = (window.navigator.appVersion.match(/android/gi), window.navigator.appVersion.match(/iphone/gi));
      var q = window.devicePixelRatio;
      i = p ? q >= 3 && (!i || i >= 3) ? 3 : q >= 2 && (!i || i >= 2) ? 2 : 1 : 1;
      return i;
    },
    spnsize: function spnsize() {
      return this.i * 15;
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_hhkjsq_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_photo_png__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_photo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_icons_photo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_emotion_png__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_emotion_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icons_emotion_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_mention_png__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_mention_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_icons_mention_png__);








var app = __WEBPACK_IMPORTED_MODULE_0__common_hhkjsq_js__["a" /* default */].app,
    hosts = __WEBPACK_IMPORTED_MODULE_0__common_hhkjsq_js__["a" /* default */].hosts,
    isIPhone = __WEBPACK_IMPORTED_MODULE_0__common_hhkjsq_js__["a" /* default */].isIPhone;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      imgList: [],
      imgLoading: false,
      hosts: hosts,
      isIPhone: isIPhone,
      icons: {
        photo: __WEBPACK_IMPORTED_MODULE_2__assets_icons_photo_png___default.a,
        emotion: __WEBPACK_IMPORTED_MODULE_3__assets_icons_emotion_png___default.a,
        mention: __WEBPACK_IMPORTED_MODULE_4__assets_icons_mention_png___default.a
      }
    };
  },

  directives: {
    focus: {
      inserted: function inserted(el, binding, vnode) {
        el.focus();
      }
    }
  },
  computed: {
    content: function content() {
      return this.$store.state.comment.content;
    },
    style: function style() {
      if (isIPhone) {
        return 'position: absolute;top: 0;';
      }
      return 'bottom: 0;';
    }
  },
  methods: {
    pub: function pub() {
      if (this.content.comTxt.length <= 0 || this.imgLoading) {
        return;
      }
      this.$store.dispatch('handeleImagePath', this.imgList);
      this.$store.dispatch('pubComment');
    },
    uploadImage: function uploadImage() {
      var _this = this;

      if (this.imgLoading) {
        return;
      }
      if (this.imgList.length >= 4) {
        return;
      }
      this.$store.dispatch('changeImageUploading');
      this.getUploadImageKey().then(function (key) {
        app.openUpload({
          url: hosts.uploadimg + '/Image/ajax/image_upload_mobile.aspx',
          params: {
            intotype: 2030,
            UploadType: 'Stream',
            key: key
          },
          start: function start() {
            _this.imgLoading = true;
          },
          success: function success(response) {
            _this.imgList.push(response.img_list[0]);
          },
          complete: function complete() {
            _this.imgLoading = false;
            _this.$store.dispatch('changeImageUploading');
          }
        });
      });
    },
    getUploadImageKey: function getUploadImageKey() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index__["b" /* fetch */])({
        url: hosts.uploadimg + '/image/ajax/GetKey.aspx',
        dataType: 'jsonp'
      })();
    },
    delImg: function delImg(index) {
      this.imgList.splice(index, 1);
    },
    handlefocus: function handlefocus() {
      if (isIPhone) {
        var el = this.$refs.textarea;
        this.$store.dispatch('focusbottom', el);
      }
    },
    handleblur: function handleblur() {
      if (isIPhone) {
        this.$store.dispatch('blurbottom');
      }
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comment__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__comment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'sq-comment': __WEBPACK_IMPORTED_MODULE_0__comment___default.a
  },
  computed: {
    show: function show() {
      return this.$store.state.comment.show;
    }
  },
  methods: {
    hide: function hide() {
      this.$store.dispatch('hideCommentArea');
      this.$store.dispatch('blurbottom');
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_share_png__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_share_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_icons_share_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_hhkjsq_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(4);





var appInfo = __WEBPACK_IMPORTED_MODULE_1__common_hhkjsq_js__["a" /* default */].appInfo;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: {
        bar: true,
        area: false
      },
      icons: {
        share: __WEBPACK_IMPORTED_MODULE_0__assets_icons_share_png___default.a
      },
      appInfo: appInfo
    };
  },


  computed: {
    commentShow: function commentShow() {
      return this.$store.state.comment.show;
    }
  },

  methods: {
    showComment: function showComment() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* inOtherBroswer */])()) return;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* isLogin */])()) {
        this.$store.dispatch('recordScrolltop');
        this.$store.dispatch('showCommentArea');
        this.$store.dispatch('focusbottom');
      }
    },
    showShare: function showShare() {
      this.$store.dispatch('showShare');
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__goTop__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__goTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__goTop__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'sq-go-top': __WEBPACK_IMPORTED_MODULE_0__goTop___default.a
  },

  data: function data() {
    return {
      show: false
    };
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_index__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      allId: 'all',
      eliteId: 'elite'
    };
  },

  methods: {
    top: function top() {
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_index__["a" /* scrollTop */])(window, window.scrollY, 0, 500, function () {
        self.$store.dispatch('reload');
      });
    }
  },
  computed: {
    activeId: function activeId() {
      return this.$store.state.list.activeId;
    },
    hasNew: function hasNew() {
      return this.$store.state.list.hasNew;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    style: function style() {
      var pdb = 100 * this.$store.state.header.ratio;
      var bgurl = this.bgsrc;
      var s = "padding-bottom: " + pdb + "%;background-image: url(" + bgurl + ");";
      return s;
    },
    bgsrc: function bgsrc() {
      return this.$store.state.header.pageInfo.HeaderImageUrl;
    },
    title: function title() {
      return this.$store.state.header.pageInfo.Title;
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directive_onceScrollInView__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(4);





/* harmony default export */ __webpack_exports__["default"] = ({
  directives: {
    scrollInViewOnce: __WEBPACK_IMPORTED_MODULE_1__directive_onceScrollInView__["a" /* default */]
  },

  data: function data() {
    return {
      preload: __WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png___default.a,
      adjustSty: {},
      imgsrc: __WEBPACK_IMPORTED_MODULE_0__assets_images_preload_png___default.a
    };
  },


  props: {
    src: {
      type: String
    }
  },

  methods: {
    show: function show() {
      var _this = this;

      this.imgsrc = this.src;
      this.$refs.img.addEventListener('load', function () {
        if (_this.$refs.img.src !== _this.src) return;
        _this.adapt();
      });
    },
    adapt: function adapt() {
      if (__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* isObjectFitCompatible */]) {
        this.adjustSty = {
          width: '100%',
          height: '100%',
          'object-fit': 'cover'
        };
        return;
      }
      var img = this.$refs.img;
      var boxRatio = this.$el.clientWidth / this.$el.clientHeight;
      var imgRatio = img.width / img.height;
      var width = void 0,
          height = void 0,
          top = void 0,
          left = void 0;
      if (imgRatio < boxRatio) {
        width = '100%';
        height = this.$el.clientWidth / imgRatio;
        left = 0;
        top = '-' + (height - this.$el.clientHeight) / 2 + 'px';
      } else if (imgRatio > boxRatio) {
        height = '100%';
        width = this.$el.clientHeight * imgRatio;
        left = '-' + (width - this.$el.clientWidth) / 2 + 'px';
        top = 0;
      } else {
        width = '100%';
        height = '100%';
        top = 0;
        left = 0;
      }

      this.adjustSty = {
        width: width,
        left: left,
        height: height,
        top: top,
        position: 'absolute'
      };
    }
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_icon_weixin_png__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_icon_weixin_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_icons_icon_weixin_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_weixinfriend_png__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_weixinfriend_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_weixinfriend_png__);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    show: function show() {
      return this.$store.state.share.show;
    }
  },
  methods: {
    hide: function hide() {
      this.$store.dispatch('hideShare');
    },
    share: function share(type) {
      this.$store.dispatch('appSharePage', type);
    }
  },
  data: function data() {
    return {
      icons: {
        wx: __WEBPACK_IMPORTED_MODULE_0__assets_icons_icon_weixin_png___default.a,
        moment: __WEBPACK_IMPORTED_MODULE_1__assets_icons_icon_weixinfriend_png___default.a
      }
    };
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    data: {
      type: Object
    }
  },

  methods: {
    hide: function hide() {
      this.$store.commit('HIDE_SWIPE');
    },
    filter: function filter(src) {
      var newSrc = src.replace(/\.thumb/g, '');
      return newSrc;
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var upmovingoutContext = '@@upmovingoutContext';

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var wHeight = window.innerHeight;
    var documentHandler = function documentHandler(e) {
      var elRect = el.getBoundingClientRect();
      var elTop = elRect.top;
      var elHeight = elRect.height;
      if (elTop < -elHeight || elTop > wHeight) {
        if (binding.expression) {
          vnode.context[el[upmovingoutContext].methodName](e);
        } else {
          el[upmovingoutContext].bindingFn(e);
        }
      }
    };

    el[upmovingoutContext] = {
      documentHandler: documentHandler,
      methodName: binding.expression,
      bindingFn: binding.value
    };
    document.addEventListener('scroll', el[upmovingoutContext].documentHandler);
  },
  unbind: function unbind(el) {
    document.removeEventListener('scroll', el[upmovingoutContext].documentHandler);
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_swipe_item_style_css__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_swipe_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_swipe_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_style_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_tab_container_item_style_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_tab_container_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_tab_container_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_tab_container_item__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_tab_container_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_tab_container_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_tab_container_style_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_tab_container_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_tab_container_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_tab_container__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_tab_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_tab_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_spinner_style_css__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_spinner_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_spinner_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_spinner__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_style_index_less__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_style_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_style_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_es6_promise_auto__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store___ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directive_clickoutside__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_hhkjsq_js__ = __webpack_require__(5);


















var appInfo = __WEBPACK_IMPORTED_MODULE_16__common_hhkjsq_js__["a" /* default */].appInfo,
    app = __WEBPACK_IMPORTED_MODULE_16__common_hhkjsq_js__["a" /* default */].app;


__WEBPACK_IMPORTED_MODULE_12_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_12_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_spinner___default.a.name, __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_spinner___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_tab_container___default.a.name, __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_tab_container___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_tab_container_item___default.a.name, __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_tab_container_item___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe___default.a.name, __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item___default.a.name, __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item___default.a);

__WEBPACK_IMPORTED_MODULE_12_vue__["default"].directive('clickoutside', __WEBPACK_IMPORTED_MODULE_15__directive_clickoutside__["a" /* default */]);
if (appInfo) {
  document.addEventListener('ChangJSBridgeReady', function () {
    init();
    app.hideMoreMenu();
  });
} else {
  init();
}

function init() {
  new __WEBPACK_IMPORTED_MODULE_12_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_14__store___["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_13__App___default.a }
  });
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_actions__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__ = __webpack_require__(5);




var app = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].app,
    hosts = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].hosts,
    isIPhone = __WEBPACK_IMPORTED_MODULE_3__common_hhkjsq_js__["a" /* default */].isIPhone;

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    content: {
      comTxt: '',
      imagePath: ''
    },

    pubbing: false,

    imgloading: false,

    show: false,

    preComment: {
      preCommentID: 0,
      preCommentInfo: null
    },

    scrollTop: 0
  },

  actions: {
    pubComment: function pubComment(_ref) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          rootState = _ref.rootState;

      if (state.pubbing || state.imgloading) {
        return;
      }
      state.pubbing = true;
      var requestData = {
        InfoID: rootState.header.pageInfo.PostId,
        ComTxt: encodeURIComponent(state.content.comTxt),
        TopicUserName: rootState.header.pageInfo.PrensenterName,
        UserID: rootState.header.pageInfo.PresenterId,
        PreCommentID: state.preComment.preCommentID,
        ImagePath: state.content.imagePath
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_actions__["a" /* pubComment2 */])({
        params: requestData,
        success: function success(response) {
          if (response.CommentID < 0) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["i" /* toast */])(response.Message);
            return;
          }
          var now = new Date();

          var preCommentInfo = state.preComment.preCommentInfo ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.preComment.preCommentInfo, {
            CommentContent: state.preComment.preCommentInfo.CommentContent.length > 100 ? state.preComment.preCommentInfo.CommentContent.substring(0, 100) + '...' : state.preComment.preCommentInfo.CommentContent
          }) : state.preComment.preCommentInfo;

          var localItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, requestData, {
            CommentID: response.CommentID,
            CreateTimeToInt: now.getTime() / 1000,
            CommentContent: decodeURIComponent(requestData.ComTxt),
            PreCommentInfo: preCommentInfo,
            UserName: app.getUserName(),
            UserID: app.getUserId(),
            UserHeadUrl: hosts.usertxcdn + '/info/getheadpic?id=' + app.getUserId(),
            UserHomeUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_actions__["b" /* getUserHomeUrl */])(app.getUserName()),
            ShowStatus: 0
          });

          state.pubbing = false;
          dispatch('hideCommentArea');
          dispatch('changActiveId', 'all');
          dispatch('unshiftAllComment', localItem);
          if (isIPhone) {
            document.body.className = '';
          }
          window.scrollTo(0, 0);
          if (isIPhone) {
            window.scrollTo(0, 0.1);
          }
        },
        error: function error(_error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_index__["i" /* toast */])('评论失败');
          state.pubbing = false;
          throw new Error(_error);
        }
      });
    },
    showCommentArea: function showCommentArea(_ref2, preComment) {
      var state = _ref2.state;

      state.show = true;
      state.content.comTxt = '';
      state.content.imagePath = '';
      state.preComment.preCommentID = preComment ? preComment.preCommentID : 0;
      state.preComment.preCommentInfo = preComment ? preComment.preCommentInfo : null;
      window.$('#j-comment-box').focus();
    },
    hideCommentArea: function hideCommentArea(_ref3) {
      var state = _ref3.state;

      state.show = false;
    },
    handeleImagePath: function handeleImagePath(_ref4, imgList) {
      var state = _ref4.state;

      if (!imgList || imgList.length === 0) {
        state.content.imagePath = '';
        return;
      }
      var arr = [];
      for (var i = 0; i < imgList.length; i++) {
        var o = imgList[i];
        var temp = [o.id, o.src, i + 1, o.size].join(',');
        arr.push(temp);
      }
      state.content.imagePath = arr.join('|');
    },
    recordScrolltop: function recordScrolltop(_ref5) {
      var state = _ref5.state;

      state.scrollTop = document.body.scrollTop;
    },
    focusbottom: function focusbottom(_ref6, el) {
      var state = _ref6.state,
          dispatch = _ref6.dispatch,
          rootState = _ref6.rootState;

      if (isIPhone) {
        dispatch('recordScrolltop');
      }
    },
    blurbottom: function blurbottom(_ref7) {
      var state = _ref7.state,
          rootState = _ref7.rootState;

      if (isIPhone) {
        document.body.className = '';
        window.scrollTo(0, state.scrollTop);
      }
    },
    changeImageUploading: function changeImageUploading(_ref8) {
      var state = _ref8.state;

      state.imgloading = !state.imgloading;
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils___ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_preload_png__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_preload_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_preload_png__);




var DEFAULT_SHARE_IMAGE = 'http://shuocdn.108sq.cn/frontEnd/wap/images/new/logo_60_60_new.png';

var ratio = 28 / 75;

var pageId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils___["k" /* queryString */])('id');

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    ratio: ratio,
    pageInfo: {
      Title: 'Live',
      HeaderImageUrl: __WEBPACK_IMPORTED_MODULE_2__assets_images_preload_png___default.a,
      ShareImageUrl: DEFAULT_SHARE_IMAGE,
      PresenterId: 0,
      PrensenterName: '',
      PostId: 0
    },
    shareInfo: {
      title: '',
      titleUrl: window.location.href,
      content: '',
      imageUrl: ''
    }
  },

  actions: {
    getPageInfo: function getPageInfo(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils___["b" /* fetch */])({
        url: __WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].GET_PAGE_INFO(pageId)
      })().then(function (response) {
        response = JSON.parse(response);
        if (response.State === 1) {
          commit('PAGE_INIT', response.Result);
          commit('SHARE_INFO_INIT', response.Result);
          dispatch('initEliteList');
          dispatch('getAllListInfo');

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils___["l" /* statistics */])('View', response.Result.PostId);
        }
      }).catch(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils___["i" /* toast */])('网络错误');
        throw new Error(error);
      });
    }
  },

  mutations: {
    PAGE_INIT: function PAGE_INIT(state, info) {
      state.pageInfo = info;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils___["m" /* setPageTitle */])(info.Title);
    },
    SHARE_INFO_INIT: function SHARE_INFO_INIT(state, info) {
      state.shareInfo.title = info.Title;
      state.shareInfo.content = info.Title;
      state.shareInfo.imageUrl = info.ShareImageUrl;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils___["n" /* setWebShare */])(state.shareInfo);
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_actions__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(4);





var DEFAULT_TIMER = 30000;
var FIRST_TIMER = 3000;

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    all: {
      id: 'all',
      list: [],
      nomore: false,
      loading: true,

      bottomRequesting: false
    },

    elite: {
      id: 'elite',
      list: [],
      nomore: false,
      loading: true,
      inited: false,

      bottomRequesting: false,

      pageInfo: {
        PageCount: 0,
        PageIndex: 1,
        PageSize: 30,
        TotalCount: 0
      }
    },

    hasNew: false,

    praiseIdList: [],
    praiseCountList: {},

    postInfo: {},
    activeId: 'all',

    timeout: null,
    interval: null
  },

  actions: {
    getAllListInfo: function getAllListInfo(_ref, callback) {
      var state = _ref.state,
          rootState = _ref.rootState,
          dispatch = _ref.dispatch;

      dispatch('loading', 'all');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["c" /* initAllList2 */])({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          orderBy: 3,
          pageSize: 15
        },
        success: function success(response) {
          dispatch('loaded', 'all');

          state.all.list = response.CommentInfoList;
          dispatch('getPraiseList', response.CommentInfoList);
          callback && callback();

          if (state.activeId === 'all') {
            dispatch('initTimer');
          }
        },
        error: function error(_error) {
          dispatch('loaded', 'all');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('网络错误');
          callback && callback();
          throw new Error(_error);
        }
      });
    },
    loading: function loading(_ref2, type) {
      var state = _ref2.state;

      state[type].loading = true;
    },
    loaded: function loaded(_ref3, type) {
      var state = _ref3.state;

      state[type].loading = false;
    },
    reload: function reload(_ref4, callback) {
      var state = _ref4.state,
          dispatch = _ref4.dispatch;

      dispatch('clearTimer');
      state.hasNew = false;
      state.all.nomore = false;
      state.elite.nomore = false;
      if (state.activeId === 'all') {
        dispatch('getAllListInfo', callback);
      } else {
        dispatch('initEliteList', callback);
      }
    },
    getPraiseList: function getPraiseList(_ref5, commentList) {
      var state = _ref5.state,
          dispatch = _ref5.dispatch;

      var idList = [];
      if (commentList.length === 0) {
        return;
      }
      commentList.forEach(function (item) {
        idList.push(item.CommentID);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["d" /* getPraiseInfoList2 */])({
        params: {
          InfoIDs: idList.join('|')
        },
        success: function success(response) {
          dispatch('handlePraiseCountAndShow', response.PraiseCounts);
        },
        error: function error(_error2) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('获取赞信息失败');
          throw new Error(_error2);
        }
      });
    },
    handlePraiseCountAndShow: function handlePraiseCountAndShow(_ref6, list) {
      var state = _ref6.state;

      if (!list || list.length === 0) {
        return;
      }
      var obj = {};
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var id = item.CommentID || item.InfoID;
        obj[id] = {
          count: item.Count,
          isShow: item.IsShow
        };
      }
      state.praiseCountList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.praiseCountList, obj);
    },
    initEliteList: function initEliteList(_ref7, callback) {
      var state = _ref7.state,
          rootState = _ref7.rootState,
          dispatch = _ref7.dispatch;

      dispatch('loading', 'elite');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["e" /* initEliteList2 */])({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          pageSize: 10,
          orderBy: 3
        },
        success: function success(response) {
          dispatch('loaded', 'elite');
          state.elite.list = response.CommentInfoList;
          dispatch('getPraiseList', response.CommentInfoList);
          dispatch('changeElitePageInfo', response.PageInfo);
          callback && callback();
        },
        error: function error(_error3) {
          dispatch('loaded', 'elite');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('网络错误');
          callback && callback();
          throw new Error(_error3);
        }
      });
    },
    getEliteMoreInfo: function getEliteMoreInfo(_ref8) {
      var state = _ref8.state,
          rootState = _ref8.rootState,
          dispatch = _ref8.dispatch;

      if (!rootState.loadmore) {
        return;
      }
      if (state.elite.nomore) {
        return;
      }
      if (state.elite.bottomRequesting) return;
      dispatch('loading', 'elite');
      state.elite.bottomRequesting = true;
      state.elite.pageInfo.PageIndex += 1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["e" /* initEliteList2 */])({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          orderBy: 3,
          pageSize: 10,
          pageIndex: state.elite.pageInfo.PageIndex
        },
        success: function success(response) {
          if (response.CommentInfoList.length > 0) {
            response.CommentInfoList.forEach(function (item) {
              state.elite.list.push(item);
            });
            dispatch('getPraiseList', response.CommentInfoList);
          }
          dispatch('changeElitePageInfo', response.PageInfo);
          state.elite.bottomRequesting = false;
          dispatch('loaded', 'elite');
        },
        error: function error(_error4) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('网络错误');
          state.elite.bottomRequesting = false;
          dispatch('loaded', 'elite');
          throw new Error(_error4);
        }
      });
    },
    changeElitePageInfo: function changeElitePageInfo(_ref9, pageInfo) {
      var state = _ref9.state;

      state.elite.pageInfo = pageInfo;
      if (state.elite.pageInfo.PageIndex >= state.elite.pageInfo.PageCount) {
        state.elite.nomore = true;
      }
    },
    changActiveId: function changActiveId(_ref10, id) {
      var state = _ref10.state,
          dispatch = _ref10.dispatch,
          rootState = _ref10.rootState;

      state.activeId = id;
      if (id === state.elite.id && !state.elite.inited) {
        dispatch('initEliteList');
        state.elite.inited = true;
      }
      var postId = rootState.header.pageInfo.PostId;
      if (id === state.all.id) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["l" /* statistics */])('All', postId);
      } else if (id === state.elite.id) {
        state.hasNew = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["l" /* statistics */])('SpecOnly', postId);
      }
    },
    initTimer: function initTimer(_ref11) {
      var state = _ref11.state,
          dispatch = _ref11.dispatch;

      dispatch('firstMoreAllRequest');

      dispatch('setTimerGetter', function () {
        dispatch('getAllMoreInfo');
      });
    },
    firstMoreAllRequest: function firstMoreAllRequest(_ref12) {
      var state = _ref12.state,
          dispatch = _ref12.dispatch;

      state.timeout = window.setTimeout(function () {
        dispatch('getAllMoreInfo');
      }, FIRST_TIMER);
    },
    handleTimer: function handleTimer(_ref13, _ref14) {
      var state = _ref13.state,
          dispatch = _ref13.dispatch;
      var oldId = _ref14.oldId,
          newId = _ref14.newId;

      if (oldId === newId) {
        return;
      }

      if (newId === state.elite.id) {
        dispatch('clearTimer');
      }

      if (newId === state.all.id) {
        dispatch('initTimer');
      }
    },
    setTimerGetter: function setTimerGetter(_ref15, fn) {
      var state = _ref15.state,
          dispatch = _ref15.dispatch;

      state.interval = setInterval(function () {
        fn && fn();
      }, DEFAULT_TIMER);
    },
    getAllMoreInfo: function getAllMoreInfo(_ref16) {
      var state = _ref16.state,
          rootState = _ref16.rootState,
          dispatch = _ref16.dispatch;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["f" /* getMoreAllList2 */])({
        params: {
          infoID: rootState.header.pageInfo.PostId,

          minCommentId: state.all.list[0] ? state.all.list[0].CommentID : 0
        },
        success: function success(response) {
          if (response.length === 0) {
            return;
          } else {
            if (document.body.scrollTop > window.innerHeight) {
              state.hasNew = true;
              return;
            }
            dispatch('unshiftAll', response);
            dispatch('getPraiseList', response);
          }
        },
        error: function error(_error5) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('网络错误');
          throw new Error(_error5);
        }
      });
    },
    clearTimer: function clearTimer(_ref17) {
      var state = _ref17.state;

      clearInterval(state.interval);
      clearTimeout(state.timeout);
    },
    getMoreAllBottomList: function getMoreAllBottomList(_ref18) {
      var state = _ref18.state,
          rootState = _ref18.rootState,
          dispatch = _ref18.dispatch,
          commit = _ref18.commit;

      if (!rootState.loadmore) {
        return;
      }
      if (state.all.bottomRequesting) {
        return;
      }
      var length = state.all.list.length;
      state.all.bottomRequesting = true;

      dispatch('loading', 'all');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["f" /* getMoreAllList2 */])({
        params: {
          infoID: rootState.header.pageInfo.PostId,
          maxCommentId: state.all.list[length - 1].CommentID,
          topNum: 10
        },
        success: function success(response) {
          if (response.length === 0) {
            commit('ALL_NOMORED');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('到底了，别扯了');
          } else {
            dispatch('pushAll', response);
            dispatch('getPraiseList', response);
          }
          state.all.bottomRequesting = false;
          dispatch('loaded', 'all');
        },
        error: function error(_error6) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('网络错误');
          state.all.bottomRequesting = false;
          dispatch('loaded', 'all');
          throw new Error(_error6);
        }
      });
    },
    unshiftAll: function unshiftAll(_ref19, list) {
      var state = _ref19.state;

      if (!Array.isArray(list) || list.length === 0) {
        return;
      }

      var _loop = function _loop(i) {
        setTimeout(function unshift() {
          state.all.list.unshift(list[i]);
          state.all.list.pop();
        }, i * 1000);
      };

      for (var i = 0; i < list.length; i++) {
        _loop(i);
      }
    },
    getPostInfo: function getPostInfo(_ref20, _ref21) {
      var state = _ref20.state;
      var id = _ref21.id,
          data = _ref21.data;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["g" /* getPostInfo2 */])({
        params: {
          id: id
        },
        success: function success(response) {
          if (response.State === 1) {
            var info = response.Result;

            var o = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data, {
              PostID: info.Id,
              PostTitle: info.Title,
              CommentContent: info.Content,
              UserName: info.TitularName,
              UserID: info.TitularId,
              UserHeadUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["h" /* getUserHeadUrl */])(info.TitularId),
              UserHomeUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["b" /* getUserHomeUrl */])(info.TitularName),
              ImagePath: info.ImagesField,
              IsPost: true
            });
            state.postInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.postInfo, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, o));
          } else {
            var _info = {
              PostID: id,
              CommentContent: '[帖子]不存在',
              IsPost: true
            };
            state.postInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.postInfo, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, _info));
          }
        },
        error: function error(_error7) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('网络错误');
          var info = {
            PostID: id,
            CommentContent: '[帖子]加载失败',
            IsPost: true
          };
          state.postInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.postInfo, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, info));
          throw new Error(_error7);
        }
      });
    },
    unshiftAllComment: function unshiftAllComment(_ref22, item) {
      var state = _ref22.state;

      state.all.list.unshift(item);
    },
    pushAll: function pushAll(_ref23, list) {
      var state = _ref23.state;

      state.all.list = state.all.list.concat(list);
    },
    handlePraise: function handlePraise(_ref24, info) {
      var state = _ref24.state,
          dispatch = _ref24.dispatch;

      var item = state.praiseCountList[info.CommentID];
      if (item) {
        if (item.isShow) {
          dispatch('postPraise', info);
        } else {
          dispatch('delPraise', info);
        }
      } else {
        dispatch('postPraise', info);
      }
    },
    delPraise: function delPraise(_ref25, info) {
      var state = _ref25.state;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["i" /* delPraise2 */])({
        params: {
          InfoID: info.CommentID
        },
        success: function success(response) {
          if (response.Status === 100) {
            state.praiseCountList[info.CommentID].isShow = true;
            state.praiseCountList[info.CommentID].count -= 1;
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])(response.Message);
          }
        },
        error: function error(_error8) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('网络错误');
          throw new Error(_error8);
        }
      });
    },
    postPraise: function postPraise(_ref26, info) {
      var state = _ref26.state,
          rootState = _ref26.rootState;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_actions__["j" /* pubPraise2 */])({
        params: {
          InfoID: info.CommentID,
          InfoMemo: info.CommentContent || 'comment' + info.CommentID,
          TopicUserName: info.UserName
        },
        success: function success(response) {
          if (response.Status === 100) {
            if (state.praiseCountList[info.CommentID]) {
              state.praiseCountList[info.CommentID].count += 1;
              state.praiseCountList[info.CommentID].isShow = false;
            } else {
              state.praiseCountList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, state.praiseCountList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, info.CommentID, {
                isShow: false,
                count: 1
              }));
            }
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])(response.Message);
          }
        },
        error: function error(_error9) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* toast */])('网络错误');
          throw new Error(_error9);
        }
      });
    }
  },

  mutations: {
    ALL_NOMORED: function ALL_NOMORED(state) {
      state.all.nomore = true;
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_index__ = __webpack_require__(4);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    show: false
  },

  actions: {
    showShare: function showShare(_ref) {
      var state = _ref.state;

      state.show = true;
    },
    hideShare: function hideShare(_ref2) {
      var state = _ref2.state;

      state.show = false;
    },
    appSharePage: function appSharePage(_ref3, type) {
      var rootState = _ref3.rootState;

      var shareInfo = {
        title: rootState.header.shareInfo.title,
        titleUrl: rootState.header.shareInfo.titleUrl,
        content: rootState.header.shareInfo.content,
        imageUrl: rootState.header.shareInfo.imageUrl,
        shareType: type
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_index__["h" /* sharePage */])(shareInfo);
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    show: false,
    imgs: [],
    activeIndex: 0
  },

  mutations: {
    HIDE_SWIPE: function HIDE_SWIPE(state) {
      state.show = false;
    },
    SHOW_SWIPE: function SHOW_SWIPE(state) {
      state.show = true;
    }
  },

  actions: {
    initSwipe: function initSwipe(_ref, _ref2) {
      var state = _ref.state,
          commit = _ref.commit;
      var imgs = _ref2.imgs,
          index = _ref2.index;

      state.imgs = imgs;
      state.activeIndex = index;
      commit('SHOW_SWIPE');
    }
  }
});

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAB+0lEQVRIib3WvU9TURzG8Q/GFxxaCpvJbWKcibrAZEJg0cUQXRr8E5h0UZOyUU2Mg/4Vji4uutAEN51UEmNCfAmocUEsAwGHOtxzabncUwppfJKmt+f39Pmec+45596h9tyc/6ETh9RHMY8X+IYdtMNnCx9DbT54oxqKjGgYd3AXlT47vYnHeILtfLFoROfxFg+PABG8D/AmZPQEJXiN8SMA8hoPGUkMNIznecMxlYSss0Wg25gYACTTRMjcBxrD/QFCMt0L2XugOYwUWisVZmcplQ7WSqW0VomumZGQvQe6Gu3T1BS1GgsLlMud9nI5bavVUk9c17pBl6O2ZpP1dapV6vUUUC6n19VqWms2e4Eu0dmwOzgdtWa9TxLW1tK2DNJo0Gr1Au3iTDaiOIQ0qNHojKx/yF72YWfdfrXbxdd9KANt9XTl70k2svwCKdZuN+hn35BGozONSdIP7Fc36FPUNj198J5037MkST1xvYOT4ccrXC+0LS+n30tLbHXNcKvF4iIzMx1PsV7SWd5j+Cx2Ohxff3ABG9nUbeDRgCFC5gb7l/dTfBggZCVkyoO2cRM/BgD5jhu6Hun5DbuKK6E3x9VKyFjtbiw6Gb5gEnXpC0e/2gz/mcTXfDH2FpRpFLekR/1FnMOpUPsr3ejvpUv4GX7Hgg4DDUz/AJvrjoonjBBmAAAAAElFTkSuQmCC"

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAABsCAMAAABXeszBAAAApVBMVEUAAAAOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEUOtEX///8Ut0kku1bp+e8vv1+56spezoQ8w2j1/PdIx3Lw+/N51phr0o3Y8+FUynz5/vuv58Ge4bRx05Le9eaJ26TM8Nem5LuX368auE/S8dyP3amD2aBkz4jC7dDl71bdAAAAGHRSTlMA9xTvucwuI02VZEDmhX2dWQvTwd5ytKQM1TuRAAAEd0lEQVRo3tWaaXPiMAyGCeEuVwtspTgXubivcvz/n7ZbZrcJtuPYJjDs8zEz7YslS5ZlVVRotibtX/WxaQIYZvejNugPG5WH8NavmcDBqLeH1VKVqp1fBggw6v1mWVqtVEpAfVItYVn9LkhifDbu1GoboELt7SlaqZ7u+jomaGAMdPzXqIMmZkdZrGeAPjW15TXrcBdmSyXCTLiXnrRYX92K+tYcQCl8yCSz9xqURLdZLDaC0ug2NMT0MQvkUjM+wZifUDLjqiCBQOnU84MaHsAgL12Z8AhycnQdHoLRfILTxK57MyAXP166SThHxDBx97EPavRZtQ/gY3m7ECnshWep2JIJ8glwcfYhcpkuFVY4ogsek6u1QwGuvN7wVq3Ns+FpimKWRDal3IaawVnYFxZiz3SCbgAM3hRlOEqm56zX2KWtUJKFpeq5Xr5YMa6U3EeqZjJmRAV2IMPPDWEIFM4UVYhAgs/cA3uLKevYcc5rzPLlOU5s4w9zH4oxqsweYZ22vXqFhJhyuX7ys/IKQdCho9rGlACuLNlPF0w5QzE1xpDsfnTgyob95GbNLWPK92tRRxsyoXYA/a9XrAUwgGJavGrEuc31Z2a502u6OipHQZsX2hHekiz3dMbc7vcJlTBlA5yujhcoz9TdeD45APEtyRhg3SbJ/HqCW74Xbfb7Y+T5VnE6aQJFKLmsIwHwN9t5Rn57Esb5hJO2JFM/gUPEMcPXyhIVsn0dtdADK8oxgh3l6Y04NcIcC0kcCATuTXKir8tJyWssYnuAEwo5ARdOPe5iAV8Ha6F3olcrY6A4oRjbsVws5MKTa7DndoBiZrBDCVxuwJmg5rglxCjFhqcGDJEwqIl0GRFwTgFgONjCX7zIHhAWWYXZWpZkvJ5YrBprSZGp5sTHlBj+MEs9Slkm5vmN5SLw/RJTCHzzY1n6eExYtTGwkFxbxjdJ27vdwwF98PpMBNSBQ5CXvshNfIS03yznNBdsy2pO92fGlwtTt+jEXJqVabkpN0PCEhWwmazcBz6+zf2xC1RgzjQXhpADufAuGC6qwJymTciFtdrirrVNqCqoSM1V89uavVSNIAcr5Pz5ChXYsRVeD7ikKSkbDAcfFYjZ6rUFOSz+FTVOvEt+0oWN0kwPbGX+buQYcvqt9a9gs5xg5sUegSNKs6dOAFEv2fu+l1pA48gvjXBuVJUOcHFTLWan6lzHa+lNmIMHfEiIWkmyo9eWn8nlSMK95dPJq5iNjJiT18GomKDGsljMZ85t7ZZyYRisHUHnqWqAIuepcIMQYT90AKo4LuayBYYu1Q1Vxkswh9AqeIJogwYzV7ZKHjNdbB1IvFin+9CNguDCbcgOmQ69LsT34ig6B+Tvgtdsl21U9Pqgj7WykcrHjeKXFX0OGw+y9J76avTUF7HGC7z2Pegl8zVeaR/yAv0yr+tPmBwolNMXe+bER+PVpln+0IcSqFVfcgqpjAmr150eu3My7tWn/rQnGv+PaU31SdT/a8r2GRPELO+lTEc/d/L7N5tydGBwGLz3AAAAAElFTkSuQmCC"

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAABsCAMAAABXeszBAAAAmVBMVEUAAADiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1fiV1f////lY2P86urndnbwoqL64uLztbXkX1/0wMDxqan98fH53Nz2y8vjWVnqf3/41tb1xMTriIjmb2/laWn+9vbzurrul5f2ycnunZ330NDsj4/ZS0bYAAAAF3RSTlMA9u4UuMwkTS6VPp6Ff+XUYVbewHRrpdhVuYcAAASMSURBVGje1ZrZlqIwEECHxX3UdpsqQEBgAPft/z9uWg8zOXRSRUQ8Y98nH/Rcs1RSSerHQ3Qnw4E9HpkGgGlOW3Zv3mn/eAXWpNcyQIFpD/vNqtrDFnCY9ofVVKsWLajGsDsNuLoDAzQZDZ9sYN+GRzB6T/i6wvVyn9WDOpiLOrIPE2rS6j7cMBvqY/x8TNYx4SlajywxP+FZzE7Tvcgz1FymxtAIAy3ZCBrC1ohoExpjVkP2Ol1byF7fmdYUGuYXY2tB49DLygBeABXmH/AKzLZ6hhhQzfZ4uLh7/CRO1ssshWpadQctcvEL+dmpNXRD4MkOO/BilDl5wGP05bDm+3GTILqEbgU7vkfHkm0GDF6ON1wHtrHKtvQ3wDH/IpsATRpggV/oJBvimhs/0yrbpkzDfERKJ2wYc83rlWQLZsT2iGWdq7QhRsxEKQUdvactsUDodq5sKz6QDLRWkQiR0sk2/J2SjbOEbcy0TNaFhU624UkjxPtAcEUVyafOV9swAALzn+0XNRv3SOkcX23DIxBMCplFLCOhi8jo1Db0yG2cnyMBIqtT25KKeWKDkgyR1yVKGy4JXXH2IToyR448hDBR2vYO15UdUOPwpFDohI2fl8bd1oPahInKtg9BSYcO7aWvIJB0ucKGRzrALVARxijzOwRZp7DloGRGLiRH5R6tIMxlGzrkwM1BxQUF/OCHF9mWgZI2kbKGKBEBQXr9aruCmgmR2G0k2RloyrY4gwyo9GSkta1dQdfmbiFCj8oXQMUJy2xA15Y7EFCrl00EQFIO1wx0besUVrdYIXL0LqiISwPhAYR6tgjSe7f4oGJKhBuWByI9eVq24y387oAKs9rm78DJUccWZ2IXImydClvi3JIQHZu7vX2Ts0GV7RKCF6OOLRdpNGkjenIvpthmj9W2+zc9IYsfGjcX7xyK5bnaFgBkexSDTdi6TJYQiUWFt52PYrFjstgpEd2rIp1ZoZYt/bpFRdQJnBz2I4QXJG18Cr+h8qARkd1tRPBU2yKt7bRH7DhhnIlzWrXtgGUScscZgIodZDFq2tK1tM2Tu+mcPd4IG+UTo1v539pUFpRJvz8Ru7eTSDKXTl/5DE/YfmOklPna+dKMzl4j2abSbV2U2RLZK52ZO3vJptItA5kI1HSYU0ck2YSuFgZ3ogpdyfaczmZPixuV7b7YuxwJECz4k/BashW6MzIsqY60+FO+E0u2ap2f0h3J32Bkkq1alwHBpPJ2ZinZGB0/i0yNm6dAacODFP26N0/8rdpasnG6PARujlTfGK6EjdXxMhho3oZGwlahW6dAYbR1b3o3scqGa4BACjSKnv4t9u4kbKQu8YDGtB65od8kwqbUxWfgmBOvDzTCJnRF/uMuQ+AYEy8rbPsUuvRTd7qmwGL067waZQdX0boQqvhZ90XMOwZ/H8T8S3D0tF7E3uC171Uvme/xSvuKF+i3eV1/onLg/xcqzKz3qvhosJrlDSt1GqpCetcKq6erx966Mu4Ta1BvxBbfoKKxXrXm96lEfWGVLV9BzKs+rO9aHd1U5fcfbBtRYOZG+6YAAAAASUVORK5CYII="

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAwCAYAAACBpyPiAAAG0ElEQVRogcXae6zWdR0H8Nc5xK24xWhhRs4TFdhGZJsxy4RSWJS5zJplzszU0hbLyg0chZfUXObUwi5TV6wra64IzTApxWpZiuYtBNEypIuo3AIV6Y/398d5eHye5/zOOZDv7ez3fX6/7+X9vXyu39O1ePFi+xCTMAU9eBVGYBy24hlsxKN4CA/g+cEM9pLBNMZwzMEHcCQO6kfbLfgdlmOpTKxfGCj5iZiH0zG+4f1W/AXrsAFPY1f5Nr6068GbMFomPgeX4ae4APfvL/IjcS4+L6tOtv/HuAF34bka/QzBNByDEzC1PI/HtzEfm/vqpLsfxI8oRM8txH+Bt+MQnIc7ahInu3EXzscbMRt/kMU8E6vx1n1BvgsLcIuc6QdwtKza7TXJdsJurMDhOBGbcDBW4v2dGvZFfgi+gy/LqizGobh5cHxbYjd+IPLwRzmiS0UZtEQn8kPwE5yKZ3EyzsKOfUS2HR7DLJGhITKhI1tVbEe+C9fhOGzHsfjePqfZHttlxW/BMPwQr2yu1I78IpwkAvhh3LhfKHbGDpnAehyArzdXaEX+PVhYymfi54MkMVwsbw9e2s+2T+FjIg/Hi6LYg2by43CNHJslIqwDwRQxPPeK4fqbGK4toiJPbzH2beWvGbfKuSdary35S+RsPY5PD4D0q8tA9+Ns0eGNhrAb0/EtLNO7E+8Vm/GGNv2eL37QTLy5Ffkp+EQpf0ENC9eEY3C3yEgX/iordRgmyPF5LT4nunwuLi1t312ev27T9xr8spRPaEV+vqime/RuU12ciuvFf/m3GJupuFgs7xPiVT6Mr2FGqfcpWe2j+iBPXBB4XzP5MSIQcLkISF2cKLIxpBCdLpPv1MdDMuFu0WyvL+87Gb9flecUvKKR/HFy/raLd1cXM3CtHJPfinHZULPtMhHQ6hiswyMd6m8sdeAt9JKvtuIG0Qh1MFrM9zA5k8diW822FRoXqo7LUbnLkwn5LvEYiTNUFxeLdtkhO/d0P9o2k6Hzea/weHlOJOQnizaAVTUHnYwzSnkR7qvZrhlDy/N5cQX6QrVAIwn515UXz4q7Wwdni/7+O66o2aYVppXnatFIfaGKyvaQ7ykv/iET6Asjxe8hxAfjZVbHta6LXUVvmwn5seXFkzU7mI1RsgqD8TSH4h2lvKJmm8qz3ETIjyov6mqK2eW5SgzNQDGjjL1D/YhscnmuZ28Lu+uFdVvisPK8tWb9dqg8xNvx3xr1h9lbRnRjZ3kxvFWLFqgEfHXN+u1QxyVoxNskifVPrCXkq+MypkYHY/XKyCM1B22FcXp3sK6wfqg8lymuR7doGTiwRgdjG8r/qTloK8wSX+hJ3Fmj/hh8pJSXVC+79a7gWFmRThjZUK7rRrRClRFYqZ6szZMJ3KNB1rrFL6kwTWc0+vh1jlkrTMYHS7nOeZ+Ec0p5UeOHbtn+9eX3jD462qR3pSbVGLgZXbhSNAfxRDthiHito2Si1zd+rFRl5ZAdpTN2SgwK76pBthkL9EZNm/XtjlxSOG3BJ5s/VuSrGc3Ey/vosArHTsPL+qjbiDMkC1zhUZ3z8+dJQne3hKdrmytU5FeI5A/VECO2wdUStBwoR6Crj/pDJfS7upCtMgDtYuQREqB/sfyeL5m7F6Aiv1NSHkSyO6UBNzR0/PHSrpWW6pIg+8/4rCSwTpIwc6coh9c01T9a8pSny4qfg6+0I9LVcK0zSbZmmGzTNe0alYG+WQYhu7ZcYtOqr3fq9Vg3SlbhN+X3dZJM2ixC+5wkcKublSckxv1Zm7Fvw+6upjupr0pqYqNE/091mACcIhnkA9p83yqXBRc09TUBNxXCjdgi2uUi/KtNnwslj/P7ZvJj8GAhs1SvSe6EESLos+QSbZeEa3eKcLczZt2iSabKyq8RT7WTkzZX0o+PYXozeaLKlsv2fAZX1ZjA/wOHS/pjqKjpVa0E80ZcWMqXy1l9sTFHjtkIfFSJtdtplS/hu2LhlsgOvBjoktTjcrEpZ8lxRnvyu0Xar5UJXCGC198U9WDQI8fkUpGJk0X/70Enfb5LJrBQJnOaCOHM/UC0EeNFg90rAv2wBOpLmivWuQ28UOLWDZIUXSnbeESnRgPANHxDcvkLRDCvLO/vaNWg7j3szZJrv0yyvXPFr75PfJBD9f9CerRojYskc3a33MSMxI8K6Xk6JAZaqcq+0CMCfIq9ffptEtc+KMmobXr9l24xTBNk9w6xt2tAbMP3xXKvUwMDIV9hlNiE6p8mJvaz/TMSGd0kbsCf9C+1Pqj/+tgqaqtSXQfJVh8sCdixkpEYJlZ2u+R51oowrlH/ur8l/gcdfYBJI/yuHgAAAABJRU5ErkJggg=="

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAArCAYAAAA3+KulAAAEEElEQVRogdXaXYhVVRQH8N9cbjNkfgxFDyb09VBZQdpDZg19aVE4Fdmbb2EZZYhPFUVQhIS9VDBdEtR6sxeNnDEqyx4UHCEUQzIb0kxGAkmtlFDL6WHty1z1Xufe2Udn/MNhnXPuXuv8/7PP3nvtdaatUqkoCJfjW8xuwWcXHsVgUSRKDe5vwVCdY3OD9hOwXmti4HZswrQW/RqikaBGaKtz7wpswFz8jttSu5GOa/ELbhKirmmd/rloJKirAYmus9pNwpd4AAfxIH5s8tkHUvuqqO8UIKrVHqrFFCGmq4bcTy3GqPrtVZCoWkHtWIKt+Fv9MVR7HMU9yXc1fh4lhwN4G/8JUYNNPHsocdyaOLdXg5WTnYY+zBgFobfw5ij8avEJDuNTMVs2g4m4Ox3PoBuDJaGuKmYAT4vXqZmB3VaAmCrWi9my2edOSVwHEvcN6Cjj+XRjT1J7tCCCFxp/YZ2YIftxBxaVsCA1eM2lI6YWRwV3WFDCnenim7Hhc148JpaDg+m8Eb5OdmZ1DBFdON6wClPTseo87Y4l25GzDl1s1MtSzsGFEFQSaVAFO3BErBtH0nUl/d7Ms58V6dQgFjbz8PLITVpCN5bj1jq/dYrZdAZeECnSK2LJaIQvxOvWNIrqoXZ8hF4hZr8Qdr9YtDuSvS/d35/a9WKFmpU+F0X0UDs+F/uaf/A6enDqrHbV2Woz3sBiLMMikXk/iZO5ZIrooR4h5hDuxXvOFXM2TuF9kdgeSv4fFsAlW9A8PCf+so+LQd8KdiS/E2IC6M7kkyWoJMYDMbi3jTLONryazt/N5JTl/JDYnf4mXrsc9OBXTMecnEA5guYnuxr/5pBI/h+n86dyAuUIqm7uisoBNybbaqHlDOQIui7ZvTkEarAn2RtyguQI6kz2jxwCNTic7JScIDmCqnunq3II1ODKZP/MCZIjaH+yN+YQqMHNye7LCZIjaGuyWdNsDR5Otj8nSI6gtckulJ8TlkXlBj7LCZQjaBN2i8TypRwSIlG9PsXLWgZyBJ3Gy+l8OWaNMs4sZ6ZQpzM4ZSenfVgpthC9mNmi/8zk1yFqBr2ZfArZPiwWNe6rxWeYJUYeU+XUbkvy+wovFsClEEEnxeZspah8fiCqme+I/c5UXJZsV7o/kNpNED3zhAI2d9BWqVSGqucFxOsWW4DpTbTdLcbg+WoKrWCI4oskfaKwMUdk47NFbjZZ1P32ifVrnfh8mTUB1EPRggiSGw1nzxcVJcPv7uSxIFAQJiZ7rITt6WLuGJEpAo8ku6uENelimeEtwaWETsEd1pREoW8nbhGJ4XzxMXi8Y5Lg2i+4/4AVZVFCmmf4K97aRhHGMXYKDSeqC+ugyKmW4nscHyNireC44LoUd0n/jfI/SabdXLMCx2oAAAAASUVORK5CYII="

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAACSUlEQVRIicXXX2jOURzH8deerV1sxi6U4gIlJJNc+FMbaf5c2JUVmQu7EMrNLijJhQuuJH9KGiGl1sqUUSglkSZapvnXipIld9JWtigX5zw2T3v2/J75PXzq1zmn3/c53/fzPef7/Z1TNq+3RVQl9mEHlmKaZHqMhoS2eVUR2zm4jeVTmKOswPuHqMVO9OczygiRyEIMoBkzooMkT30BkPlYhqdonQxkb4R4h5W4gW8FJi9GjXiBKlyJT9VEINlNchhfUwTIagBrcCGOW4XoLB5vVIEVsX8/ZYCZ2IjVWIRZ+IJqIRnuYe54kMrYT2M5MmjCfmFJynPed2G2EKE//FVIT5txAnVx/B138UDIlk84ECGGsC1tkFqcM7bX3uMkrvnzXzdjV+zvxps0QepwU0jRIRzBeYzm2C3EJSHdz6Izd6K/AVmLbqHmPMN2fMhj2xntnuDgRAaZKUI04E6cvDNC5YMgLNHbCJsbLUwtIguESFThMvbgZ4HfrCs0abERqcYtYYN2J4RIpGJBTgkV8bXwEUsFguKWZr2Qdj8ixFBKDI+KASnHGSH9TgsfsbRUT/KlaRFqxkccTRHit5KAlOFQ7B/D8P8CacQSfMbVUkAkBWmKbac8xSgNJdmsF4Uzy/VSQWRBRoUzyXQTn0leCSW8FMreFIYy6I2DDSVyNpk2xbY/g444OC6U7n+l2ugTOjJoR59QunuwFTUlBKiJPnqiz5dor8AIthi723SVECJXfdH3SDZ9B7EKbXiuREUrajj6aBPuUYPwC8CWbBz7Z1TKAAAAAElFTkSuQmCC"

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(207),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(162)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(213),
  /* scopeId */
  "data-v-a651d934",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(217),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(163)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(214),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(210),
  /* scopeId */
  "data-v-6aeb8ed2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(211),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(212),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(201),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(206),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(215),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(160)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  "data-v-37bf2667",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(218),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(216),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-item', {
    attrs: {
      "data": _vm.isPost ? _vm.postInfo : _vm.data,
      "show-date": _vm.showDate,
      "is-incard": _vm.isPost ? _vm.isInCard : false
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-card-imgs"
  }, [_c('ul', {
    class: _vm.imgsClassName
  }, [_vm._l((_vm.imgs), function(img, i) {
    return (i <= 2) ? _c('li', {
      staticClass: "m-card-img-wrapper",
      on: {
        "click": function($event) {
          return _vm.showSwipe(i)
        }
      }
    }, [_c('sq-img', {
      attrs: {
        "src": img.src
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.imgs.length > 3) ? _c('span', {
    staticClass: "m-card-imgs-count fz11"
  }, [_vm._v(_vm._s(_vm.imgs.length) + "张")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "nav",
    class: {
      'm-nav': true, 'm-nav--fixed': _vm.isOutofView
    }
  }, [_c('nav', [_c('div', {
    class: {
      active: _vm.activeId === _vm.allId, 'nav-item': true
    }
  }, [_c('span', {
    staticClass: "fz15",
    on: {
      "click": function($event) {
        return _vm.changeActive(_vm.allId)
      }
    }
  }, [_vm._v("全部")])]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeId === _vm.eliteId, 'nav-item': true
    }
  }, [_c('span', {
    staticClass: "fz15",
    on: {
      "click": function($event) {
        return _vm.changeActive(_vm.eliteId)
      }
    }
  }, [_vm._v("精华")])])])])
},staticRenderFns: []}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['m-fixed-buttons']
  }, [_c('sq-go-top')], 1)
},staticRenderFns: []}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sq-loadmore', {
    attrs: {
      "top-method": _vm.topMethod
    }
  }, [_c('sq-timeline', _vm._l((_vm.data), function(item, i) {
    return _c('sq-timeline-item', {
      key: item.CommentID
    }, [(_vm.showDate(i, 'year')) ? _c('div', {
      staticClass: "m-timeline-time--year fz11",
      attrs: {
        "slot": "yeartime"
      },
      slot: "yeartime"
    }, [_vm._v("\n        " + _vm._s(_vm.formateDate(item.CreateTimeToInt, 'year')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      class: {
        'm-timeline-item': true,
        'm-timeline-item--head': _vm.showDate(i, 'year'),
          'm-timeline-item--notime': !_vm.showDate(i, 'date'),
          'm-timeline-item--tail': i === _vm.data.length - 1 ? true : _vm.showDate(i + 1, 'year'),
          'm-timeline-item--last': i === _vm.data.length - 1
      }
    }, [(_vm.showDate(i, 'date')) ? _c('div', {
      staticClass: "m-timeline-time--day fz12"
    }, [_vm._v("\n          " + _vm._s(_vm.formateDate(item.CreateTimeToInt, 'date')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('sq-card', {
      attrs: {
        "data": item,
        "show-date": _vm.showDate(i, 'date')
      }
    }, [(item.PreCommentInfo) ? _c('sq-card-incard', {
      attrs: {
        "data": item.PreCommentInfo,
        "isInCard": true
      }
    }) : _vm._e()], 1)], 1)])
  }), 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "m-share",
    on: {
      "click": _vm.hide
    }
  }, [_c('section', {
    staticClass: "m-share-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "m-share-box-top"
  }, [_c('dl', {
    on: {
      "click": function($event) {
        return _vm.share(3)
      }
    }
  }, [_c('dt', [_c('img', {
    attrs: {
      "src": _vm.icons.wx
    }
  })]), _vm._v(" "), _c('dd', {
    staticClass: "fz14"
  }, [_vm._v("微信")])]), _vm._v(" "), _c('dl', {
    on: {
      "click": function($event) {
        return _vm.share(4)
      }
    }
  }, [_c('dt', [_c('img', {
    attrs: {
      "src": _vm.icons.moment
    }
  })]), _vm._v(" "), _c('dd', {
    staticClass: "fz14"
  }, [_vm._v("朋友圈")])])]), _vm._v(" "), _c('div', {
    staticClass: "m-share-cancel fz15",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n      取消\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-adaptimg-wrapper"
  }, [_c('img', {
    directives: [{
      name: "scroll-in-view-once",
      rawName: "v-scroll-in-view-once",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "img",
    style: (_vm.adjustSty),
    attrs: {
      "src": _vm.imgsrc
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "m-footer-layout-comment",
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "click": _vm.hide
    }
  }, [_c('sq-comment')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['m-gotop-img', {
      'm-gotop-img--new': _vm.hasNew
    }],
    on: {
      "click": _vm.top
    }
  })
},staticRenderFns: []}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'm-card': !_vm.isInCard, 'm-card-incard': _vm.isInCard, 'm-card--elite': _vm.data.ShowStatus === 1, fz15: true
    }
  }, [_c('div', {
    staticClass: "m-card-header"
  }, [_c('a', {
    attrs: {
      "href": _vm.data.UserHomeUrl
    }
  }, [(!_vm.isInCard) ? _c('div', {
    staticClass: "m-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.UserHeadUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fz15 m-avatar--name"
  }, [_vm._v("\n        " + _vm._s(_vm.data.UserName) + "\n      ")])]), _vm._v(" "), (_vm.isHost) ? _c('span', {
    staticClass: "fz11 m-avatar-name--host"
  }, [_vm._v("主持人")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "m-card-body"
  }, [(_vm.data.PostTitle) ? _c('h4', [_vm._v(_vm._s(_vm.data.PostTitle))]) : _vm._e(), _vm._v(" "), (_vm.filteredContentLength > 100 && _vm.openAllShow) ? _c('div', [_c('span', {
    staticClass: "fz16",
    domProps: {
      "innerHTML": _vm._s(_vm.filteredContent.substring(0, 100))
    }
  }), _vm._v("\n      ..."), _c('a', {
    staticClass: "c-blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.openAll
    }
  }, [_vm._v("全文")])]) : _c('div', [_c('span', {
    staticClass: "fz15",
    domProps: {
      "innerHTML": _vm._s(_vm.filteredContent)
    }
  }), _vm._v(" "), (_vm.filteredContentLength > 100 && !_vm.openAllShow) ? _c('a', {
    staticClass: "c-blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closeAll
    }
  }, [_vm._v("收起")]) : _vm._e()]), _vm._v(" "), (_vm.imgLists.length > 0 && !_vm.videoSrc) ? _c('sq-card-images', {
    attrs: {
      "imgs": _vm.imgLists
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoSrc) ? _c('sq-card-video', {
    attrs: {
      "src": _vm.videoSrc
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "m-card-footer"
  }, [(_vm.data.IsPost) ? _c('a', {
    staticClass: "fz13 m-card-actions--post",
    attrs: {
      "href": _vm.postHref
    }
  }, [_vm._v("查看原帖")]) : _vm._e(), _vm._v(" "), (!_vm.data.IsPost) ? _c('a', {
    class: ['m-card-actions--favor', 'fz13', {
      'm-card-actions--favored': _vm.isFavored
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handlePraise
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFavored),
      expression: "!isFavored"
    }]
  }, [_vm._v("赞")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.favoredCount && _vm.isFavored),
      expression: "favoredCount && isFavored"
    }]
  }, [_vm._v(_vm._s(_vm.favoredCount))])]) : _vm._e(), _vm._v(" "), (!_vm.data.IsPost) ? _c('a', {
    staticClass: "m-card-actions--reply fz13",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.reply
    }
  }, [_vm._v("回复")]) : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-card-incard"
  }, [_c('div', {
    staticClass: "m-card-incard-header"
  }, [_c('span', {
    staticClass: "fz15"
  }, [_vm._v("@" + _vm._s(_vm.data.UserName))]), _vm._v(" "), (_vm.data.UserName === (_vm.data.TopicUserName || _vm.PrensenterName)) ? _c('span', {
    staticClass: "fz11 m-avatar-name--host"
  }, [_vm._v("主持人")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "m-card-incard-time fz12"
  }, [_vm._v(_vm._s(_vm.data.CreateTime))])]), _vm._v(" "), _c('div', {
    staticClass: "m-card-incard-body"
  }, [_c('p', {
    staticClass: "fz15",
    domProps: {
      "innerHTML": _vm._s(_vm.commentContent)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-pos-r",
    attrs: {
      "id": "app"
    }
  }, [(_vm.swipe.show) ? _c('sq-swipe', {
    attrs: {
      "data": _vm.swipe
    }
  }) : _vm._e(), _vm._v(" "), _c('sq-header'), _vm._v(" "), _c('sq-content'), _vm._v(" "), _c('sq-footer'), _vm._v(" "), _c('sq-comment-area'), _vm._v(" "), _c('sq-func-buttons'), _vm._v(" "), _c('sq-share')], 1)
},staticRenderFns: []}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    style: ({
      transform: ("translateY(" + _vm.translate + "px)"),
      transition: _vm.transition
    })
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('mt-spinner', {
    attrs: {
      "type": "snake",
      "color": "#ff6b65",
      "size": _vm.spnsize
    }
  })], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "commentBox",
    staticClass: "m-footer-comment",
    style: (_vm.style),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.comTxt),
      expression: "content.comTxt"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    ref: "textarea",
    staticClass: "fz13 m-footer-comment-textarea",
    attrs: {
      "placeholder": "我来说两句",
      "id": "j-comment-box"
    },
    domProps: {
      "value": (_vm.content.comTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "comTxt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-footer-comment-btngrp"
  }, [_c('button', {
    staticClass: "c-btn-icons",
    on: {
      "click": _vm.uploadImage
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.photo
    }
  })]), _vm._v(" "), (false) ? _c('span', {
    staticClass: "c-btn-icons"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.emotion
    }
  })]) : _vm._e(), _vm._v(" "), (false) ? _c('span', {
    staticClass: "c-btn-icons"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.mention
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    class: ['c-post', 'fz15', {
      active: _vm.content.comTxt.length > 0 && !_vm.imgLoading
    }],
    on: {
      "click": _vm.pub
    }
  }, [_vm._v("发布")])]), _vm._v(" "), (_vm.imgList.length > 0 || _vm.imgLoading) ? _c('div', {
    staticClass: "m-footer-comment-imgs-preview"
  }, [_c('ul', [_vm._l((_vm.imgList), function(item, index) {
    return _c('li', {
      staticClass: "img-wrapper"
    }, [_c('img', {
      attrs: {
        "src": _vm.hosts.showimg + item.src
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "del fz12",
      on: {
        "click": function($event) {
          return _vm.delImg(index)
        }
      }
    }, [_vm._v("x")])])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgList.length < 4),
      expression: "imgList.length < 4"
    }],
    class: ['img-wrapper', 'add', {
      'loading': _vm.imgLoading
    }],
    on: {
      "click": _vm.uploadImage
    }
  })], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.commentShow) ? _c('footer', [_c('div', {
    staticClass: "m-footer-layout-bar"
  }, [_c('div', {
    staticClass: "m-fixed-b m-footer-bar"
  }, [_c('input', {
    staticClass: "fz14 m-footer-bar-input",
    attrs: {
      "type": "text",
      "readonly": "",
      "value": "我来说两句.."
    },
    on: {
      "click": _vm.showComment
    }
  }), _vm._v(" "), (_vm.appInfo) ? _c('span', {
    staticClass: "m-footer-share fz14",
    on: {
      "click": _vm.showShare
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.share
    }
  }), _c('span', [_vm._v("分享")])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-in-view-once",
      rawName: "v-scroll-in-view-once",
      value: (_vm.scrollIn),
      expression: "scrollIn"
    }],
    staticClass: "m-card-videp-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error && !_vm.videoLoaded),
      expression: "!error && !videoLoaded"
    }],
    staticClass: "m-spinner"
  }, [_c('img', {
    attrs: {
      "src": _vm.loading
    }
  })]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error && _vm.videoLoaded),
      expression: "!error && videoLoaded"
    }, {
      name: "scroll-out-view",
      rawName: "v-scroll-out-view",
      value: (_vm.scrollOut),
      expression: "scrollOut"
    }],
    ref: "video",
    class: ['m-card-video', {
      'paused': _vm.paused
    }],
    attrs: {
      "src": _vm.presrc,
      "controls": _vm.isIPhone
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "c-va-m"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.del
    }
  }), _vm._v(" "), _c('span', [_vm._v("[视频资源]加载失败")]), _vm._v(" "), _c('span', {
    staticClass: "c-blue",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("重新加载")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canvasSupported && _vm.beforePlay && !_vm.error),
      expression: "canvasSupported && beforePlay && !error"
    }],
    staticClass: "firstFrame",
    on: {
      "click": _vm.play
    }
  }, [_c('canvas', {
    ref: "canvas"
  }), _vm._v(" "), _c('div', {
    staticClass: "m-card-video-controls"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isIPhone && _vm.duration),
      expression: "!isIPhone && duration"
    }],
    staticClass: "m-card-video-dutation fz13"
  }, [_vm._v(_vm._s(_vm.duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.icons.pause
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoLoaded && (_vm.paused || _vm.ended) && !_vm.isIPhone),
      expression: "videoLoaded && (paused || ended) && !isIPhone"
    }],
    staticClass: "firstFrame",
    on: {
      "click": _vm.play
    }
  }, [_c('div', {
    staticClass: "m-card-video-controls"
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.pause
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pulldown', {
    ref: "reflash",
    attrs: {
      "top-method": _vm.topLoadMore
    }
  }, [_c('div', {
    staticClass: "mint-loadmore-top",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "top"
    },
    slot: "top"
  }, [_c('span', {
    attrs: {
      "v-show": _vm.topStatus == 'loading'
    }
  }, [_c('mt-spinner', {
    staticStyle: {},
    attrs: {
      "color": "#ff6634"
    }
  })], 1)]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "m-header"
  }, [_c('div', {
    staticClass: "m-header-bg",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "m-header-title fz15"
  }, [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: []}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "c-ov-h"
  }, [_vm._t("yeartime"), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-after-block"
  }, [_c('sq-nav', {
    attrs: {
      "active-id": _vm.active
    }
  }), _vm._v(" "), _c('mt-tab-container', {
    staticClass: "page-tabbar-tab-container",
    attrs: {
      "value": _vm.active
    }
  }, [_c('mt-tab-container-item', {
    attrs: {
      "id": _vm.allId
    }
  }, [_c('sq-live', {
    attrs: {
      "data": _vm.allList.list,
      "top-func": _vm.allTop
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allList.loading),
      expression: "allList.loading"
    }],
    staticClass: "m-nomore fz12"
  }, [_vm._v("加载中")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allList.list.length === 0 && !_vm.allList.loading),
      expression: "allList.list.length === 0 && !allList.loading"
    }],
    staticStyle: {
      "height": "9rem"
    }
  }, [_c('div', {
    staticClass: "m-nomore fz12"
  }, [_vm._v("暂时没有")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allList.nomore && !_vm.allList.loading),
      expression: "allList.nomore && !allList.loading"
    }],
    staticClass: "m-nomore fz12"
  }, [_vm._v("到底了，别扯了")])])], 1), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": _vm.eliteId
    }
  }, [_c('sq-live', {
    attrs: {
      "data": _vm.eliteList.list,
      "top-func": _vm.eliteTop
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.eliteList.loading),
      expression: "eliteList.loading"
    }],
    staticClass: "m-nomore fz12"
  }, [_vm._v("加载中")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.eliteList.list.length === 0 && !_vm.eliteList.loading),
      expression: "eliteList.list.length === 0 && !eliteList.loading"
    }],
    staticStyle: {
      "height": "9rem"
    }
  }, [_c('div', {
    staticClass: "m-nomore fz12"
  }, [_vm._v("暂时没有")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.eliteList.nomore && _vm.eliteList.list.length > 0),
      expression: "eliteList.nomore && eliteList.list.length > 0"
    }],
    staticClass: "m-nomore fz12"
  }, [_vm._v("到底了，别扯了")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-swipe', {
    staticClass: "m-swipe",
    attrs: {
      "auto": 0,
      "defaultIndex": _vm.data.activeIndex,
      "continuous": false
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hide($event)
      }
    }
  }, _vm._l((_vm.data.imgs), function(item) {
    return _c('mt-swipe-item', {
      key: "item.id"
    }, [_c('img', {
      attrs: {
        "src": _vm.filter(item.src)
      },
      on: {
        "mousewheel": function($event) {
          $event.preventDefault();
        },
        "DOMMouseScroll": function($event) {
          $event.preventDefault();
        }
      }
    })])
  }), 1)
},staticRenderFns: []}

/***/ })
],[104]);


// WEBPACK FOOTER //
// static/js/app.0ac124844e8f6cfefc5a.js